/// <reference path="../LayoutDesigner.js"/>
(function (sb) {
    var me = (sb.RespondentTableCache = {});
    var cache = {};
    var tablecache = {};
    var tableDataCache = {};
    var settingsCache = {};

	me.saveSettingsToCache = function (settings, id) {
		settingsCache[id] = settings;
	};

	me.getSettingsFromCache = function (id) {
		return settingsCache[id];
	};

	me.setVariableToCache = function (variable, id) {
		cache[id] = variable;
	};
	me.getVariableFromCache = function (id) {
		return cache[id];
	};
	me.setTableToCache = function (variable, id) {
		tablecache[id] = variable;
	};
	me.getTableFromCache = function (id) {
		return tablecache[id];
	};
	me.setTableDataToCache = function (data, id) {

		tableDataCache[id] = data;
	};
	me.getTableDataFromCache = function (id) {
		return tableDataCache[id];
	};

})(window.Storyboard = (window.Storyboard || {}));
//---------------------------------------------------------
window.RespondentTableSetup = {
    colSorts: {},
    currentLayoutElementItem: [],
    isSetupCompleted: true,
    isLoaded: false,
    setupEditPanel: function (contentElement) {
        //contentElement has to have type LayoutElementItem
        RespondentTableSetup.isSetupCompleted = false;
        $('#txtAvailVar').val('');
        if (!RespondentTableSetup.isLoaded) {
            Storyboard.Dependency.start('RESPONDENTTABLESETUP', 'settings');
            $.when(RespondentTableSetup.loadFilters(),
                RespondentTableSetup.loadFormReports(),
                RespondentTableSetup.loadLayoutElements(),
                RespondentTableSetup.doesProjectHaveHFilters())
                .done(function (data1, data2, data3, data4) {
                    RespondentTableSetup.isLoaded = true;
                    if (data1)
                        RespondentTableSetup.bindFilters(data1[0].d);
                    RespondentTableSetup.bindFormReports(data2[0].d);
                    RespondentTableSetup.bindLayoutElements(data3[0].d, contentElement.layoutElementId);
                    RespondentTableSetup.SetRespondentTableSettings(contentElement);
                    if (data4[0].d == false)
                        $("#chbUseHFilterRights").closest("span").hide();
                });
        } else {
            Storyboard.Dependency.start('RESPONDENTTABLESETUP', 'settings');
            $.when(RespondentTableSetup.loadLayoutElements())
                .done(function (data1) {
                    RespondentTableSetup.bindLayoutElements(data1.d, contentElement.layoutElementId);
                    RespondentTableSetup.SetRespondentTableSettings(contentElement);
                });
        }
        Storyboard.Dependency.start('RESPONDENTTABLESETUP', 'themes');
        RespondentTableSetup.loadThemesList(10);
        RespondentTableSetup.currentLayoutElementItem = contentElement;

        $('#chkrtVS').bind('click', function () {
            $("#ddlrtFilterCalcType").change();
        });
    },
    clearEditPanel: function() {
        RespondentTableSetup.currentLayoutElementItem = [];
        RespondentTableSetup.removeWizard();
        $('#selectedVarBox').empty();
    },
    SetRespondentTableSettings: function (contentElement) {
        return Helpers.perfJSonCall({
            method: 'GetRespondentTableSettings',
            message: 'Loading settings',
            data: { guid: contentElement.guid, layoutElementID: contentElement.layoutElementId || 0 },
            service: 'RespondentTableSetup',
            successCallback: function (res) {
                RespondentTableSetup.loadAllvariables(contentElement, res);
                Storyboard.Dependency.complete('RESPONDENTTABLESETUP', 'settings');
            }
        });
    },
    GetTemplateData: function (templateId, callback, templateElementItemId) {
        var data = {
            templateDataGroupId: templateElementItemId,
            templateId: templateId
        };

        Helpers.perfJSonCall({
            method: "TemplateDataGroupData", data: data,
            successCallback: function (result) { callback(result); },
            fixCasing: true
        });
    },

    BindTemplateData: function (templateData) {
        if (templateData.length === 0) {
            $('#wizardRespondent .dataSection').hide();
            $('#wizardRespondentVariables').closest('fieldset').removeClass('expandable').addClass('collapsable');
            return;
        }
        $("#rtTemplateQA").empty();
        $("#rtTemplateFilters").empty();
        for (var i = 0; i < templateData.length; i++) {
            if (templateData[i].isWizard) {
                if (templateData[i].type.includes("rtQnA") || templateData[i].type.includes("rtQA"))
                    $("#rtTemplateQA").append('<li>' + templateData[i].data + '</li>');
                else if (templateData[i].type.includes("Filter"))
                    $("#rtTemplateFilters").append('<li>' + templateData[i].data + '</li>');
            }
        }
    },
    loadAllvariables: function (contentElement, settings) {
        return Helpers.perfJSonCall({
            method: 'LoadAllVariables',
            service: 'RespondentTableSetup',
            message: 'Loading variables',
            successCallback: function (res) {
                $.each(res, function () {
                    RespondentTableSetup.setVaraibleToCache(this, this.QuestionID);
                });
                if (window.IsFormReport) {
                    HTMLHelpers.bindSelect($('#ddlClientIdVariable'), res, 'QuestionID', 'QuestionText', false, false, false, false, ["Code", "QuestionText"]);
                    $('#ddlClientIdVariable option[value=-1]').remove();
                }
                RespondentTableSetup.loadAvailVariables(res);
                if (contentElement.templateId != null)
                    RespondentTableSetup.GetTemplateData(contentElement.templateId, function (data) {
                        RespondentTableSetup.BindTemplateData(data);
                    }, settings.TemplateElementItemId);
                // bindRTSettings should calls only after all variables are loaded
                RespondentTableSetup.bindRTSettings(settings);
            }
        });
    },
    setDisplayGroupedAnswersOptionVisibility: function (questionID, filter) {
        Helpers.perfJSonCall({
            method: 'CheckDisplayGroupedAnswersOptionStatus',
            data: {
                questionID: questionID
            },
            service: 'RespondentTableSetup',
            successCallback: function (data) {
                if (!data) filter.find("#ddlAnswerFormat option:eq(2)").attr('disabled', 'disabled');
            }
        });
    },
    saveSetup: function (layoutElementItem) {
        var leguid = "";

        var tableLayoutElem = Storyboard.LayoutDesigner.getLayoutElementByElementItem(layoutElementItem);
        leguid = tableLayoutElem.guid;
        RespondentTableSetup.bindRowsDefs();
        var respondentTableData = RespondentTableSetup.getRespondentTableSettingsData(leguid);

        Helpers.perfJSonCall({
            method: 'SaveRespondentTableSettings',
            data: {
                guid: layoutElementItem.guid,
                layoutElementID: layoutElementItem.layoutElementId || 0,
                settings: respondentTableData
            },
            service: 'RespondentTableSetup',
            successCallback: function (res) {
                var items = [tableLayoutElem];
                if (window.IsFormReport)
                    Storyboard.LayoutDesigner.loadFormContent([tableLayoutElem]);
                else
                    Storyboard.LayoutDesigner.loadStorytellerContentForElements(items, true, false, 0, 0, leguid);

                if (res == "OK" && !Storyboard.LayoutDesigner.isUnsaved)
                    Storyboard.LayoutDesigner.refreshSlideToplineCompatibility();
            }
        });
    },
    loadTabs: function () {
        $("#resptabholder").tabs("destroy");
        $('#resptabholder').removeClass('ui-widget');
        $("#resptabholder").tabs({
            show: function (evt, ui) {
                if (ui.index === 1) {
                    $('#rtFilterBox .filterboxHeaderWrapper td').equalHeights();
                }
            }
        });
        $(".rt_StyleTable").find(".ColorTextbox").DUIColorPicker({ layout: 'template' });

    },
    loadAvailVariables: function (settingsList) {
        for (var i in settingsList) {
            settingsList[i].aiIcon = settingsList[i].IsAICompute ? Storyboard.Constants.aiIconEntity : '';
        }
        
        HTMLHelpers.bindSelect($('#availVarBox'), settingsList, 'QuestionID', 'QuestionText', false, false, false, false, ["aiIcon", "Code", "QuestionText"]);
        if ($("#chbRTShowQuestionCode").is(":checked"))
            HTMLHelpers.resetOptionsTexts($("#availVarBox"), ["Code", "QuestionText"], " - ");

        $("#availVarBox option").each(function () {
            var id = $(this).val();
            var variable = Storyboard.RespondentTableCache.getVariableFromCache(id);
            if (variable) {
                $(this).attr('title', HTMLHelpers.htmlDecode(variable.QuestionFullText));
            }
            else {
                RespondentTableSetup.getVariableById(id)
                var servVar = Storyboard.RespondentTableCache.getVariableFromCache(id);
                if (servVar) {
                    $(this).attr('title', HTMLHelpers.htmlDecode(servVar.QuestionFullText));
                }
            }
        });
        Storyboard.LayoutControls.hideLoadingBar();
        RespondentTableSetup.clearMovedVariables();
    },
    clearMovedVariables: function () {
        $("#selectedVarBox option").each(function (opt) {
            var option = $("#selectedVarBox option").eq(opt);
            $('#availVarBox option[value="' + option.attr("value") + '"]').remove();
        });
    },
    filterVariables: function () {
        if ($('#loadFeedBack').is(':hidden')) {
            Storyboard.LayoutControls.showLoadingBar('Loading variables');
        }
        var filter = $('#txtAvailVar').val();
        var questionType = $("#ddlrtFilterCalcType").val();
        var varSubsets = RespondentTableSetup.getVarSubs();
        RespondentTableSetup.getFilterVariables(filter, questionType, varSubsets, function(res) {
            $.each(res, function () {
                RespondentTableSetup.setVaraibleToCache(this, this.QuestionID);
            });
            RespondentTableSetup.loadAvailVariables(res);
        });
    },
    getFilterVariables: function (filter, questionType, varSubsets, callback) {
        var data = {
            filterText: filter,
            questionType: questionType,
            variableSubsets: varSubsets,
            filterByCode: $("#chbRTShowQuestionCode").attr("checked")
        }
        Helpers.perfJSonCall({
            method: "FilterRespondentTableQuestions",
            data: data,
            service: 'RespondentTableSetup',
            successCallback: callback,
            fixCasing: false
        });
    },
    getVariableById: function (questionId) {
        var data = {
            questionId: questionId
        }
        Helpers.perfJSonCall({
            method: "GetRespondentTableQuestionsById",
            service: 'RespondentTableSetup',
            data: data,
            successCallback: function (res) {
                if (res) {
                    RespondentTableSetup.setVaraibleToCache(res, questionId);
                }
            },
            fixCasing: false
        });
    },
    moveItems: function (sender) {
        var id = $(sender).attr("id");
        var selectFrom = id === "btnMoveToSelVar" ? "#availVarBox" : "#selectedVarBox";
        var moveTo = id === "btnMoveToAvailVar" ? "#availVarBox" : "#selectedVarBox";
        var isSelectedDel = moveTo === "#availVarBox";
        var selectedItems = $(selectFrom + " option:selected");
        var output = [];

        selectedItems.each(function () {
            var $this = $(this);
            var alreadyInList = $(moveTo).find("option[value=" + $this.val() + "]").length > 0;
            if (!alreadyInList)
                output.push(this.cloneNode(true));
        });

        if (moveTo === "#selectedVarBox") {
            $(moveTo).append(output);
        }

        RespondentTableSetup.refreshSortCriteriaOptions(selectedItems, output, id);
		RespondentTableSetup.refreshWebVariableOptions(selectedItems, output, id);
		selectedItems.remove();
		RespondentTableSetup.updateHideLowDataOptions();

        if (moveTo === "#availVarBox") {
            $('#ddlrtFilterCalcType,#lbrtVS').trigger('change');
        }

        //if we delete variable, then we have to delete all information about it from the Columns&Rows definition tab
        if (isSelectedDel) {
            RespondentTableSetup.bindRowsDefs();
        }
    },
    refreshSortCriteriaOptions: function (selectedItems, selectedItemsString, senderId) {
        var action = senderId === 'btnMoveToAvailVar' ? 'delete' : 'insert';

        if (action === 'delete') {

            $('.ddlSortCriteria').each(function () {
                var $currentDDL = $(this);
                var baseValue = $currentDDL.val();
                $.each(selectedItems, function () {
                    var currentValue = $(this).val();
                    if (($(this).val() !== "-2")) {
                        if ($(this).val() === $currentDDL.val())
                            if ($currentDDL.siblings("button").length > 0) {
                                $currentDDL.siblings("button").click();
                            } else if ($currentDDL.parent().next().find(".ddlSortCriteria").length > 0) {
                                $currentDDL.parent().next().find("button").remove();
                                $currentDDL.parent().remove();
                            }
                        $currentDDL.find('option[value="' + currentValue + '"]').remove();

                        if ($currentDDL.val() !== baseValue && $currentDDL.val() === "-2")
                            $currentDDL.siblings(".ddlSortOrder").val("1");
                    }
                })
            });
        } else {
            $('.ddlSortCriteria').each(function () {
                if ($(selectedItemsString[0]).val() !== "-2") {
                    $(this).append(selectedItemsString.join(""));
                }

            });
        }
    },
    refreshWebVariableOptions: function (selectedItems, selectedItemsString, senderId) {
        var action = senderId === 'btnMoveToAvailVar' ? 'delete' : 'insert';

        if (action === 'delete') {
            $('.ddlWebVariableId').each(function () {
                var $currentDDL = $(this);
                $.each(selectedItems, function () {
                    var currentValue = $(this).val();
                    if ($(this).val() !== "-3") {
                        $currentDDL.find('option[value="' + currentValue + '"]').remove();
                    }
                })
            });
        } else {
            $('.ddlWebVariableId').each(function () {
                if ($(selectedItemsString[0]).val() !== "-3") {
                    $(this).append(selectedItemsString.join(""));
                }
            });
        }
    },
    toggleWebVariables: function (selectedVariables) {
        var openEnded = selectedVariables.filter(function (v) {
            var variable = Storyboard.RespondentTableCache.getVariableFromCache(v.QuestionID);
            if (variable) return variable.QuestionT === 4; // Open ended (question type 4)
            return false;
        });

        if (openEnded.length > 0) {
            $('#rtWebVariables .webVariablesValidationMessage').css('display', 'none');
            $('#rtWebVariables .webVariablesControls').css('display', '');
        } else {
            $('#rtWebVariables .webVariablesValidationMessage').css('display', '');
            $('#rtWebVariables .webVariablesControls').css('display', 'none');
        }
    },
    bindFilters: function (filterArray) {
        var template = $("#rtFilterBox > .rtfilterboxTemplate");
        template.show();
        Storyboard.GuiEvents.bindFilters(filterArray, "rtFilterBox", "rtfilterboxTemplate", false);
        Storyboard.GuiEvents.bindOptionalFilters(filterArray, "optFilterBoxRT", "optionFilterTemplateRT", "optionalFilterSettingsRT");
        Storyboard.GuiEvents.bindOptionalFiltersCheckAll("optFilterBoxRT");
        template.hide();
    },
    initializeSortTemplate: function () {

        var $options = $("#selectedVarBox  > option[value!=-2]").clone();

        $('#sortCriteriaTemplate .ddlSortCriteria option:not(:first)').remove();
        $('#sortCriteriaTemplate .ddlSortCriteria').append($options);
    },
    initializeWebVariableTemplate: function () {
        var $options = $("#selectedVarBox  > option").clone();

        $('#webVariableTemplate .ddlWebVariableId option:not(:first)').remove();
        $('#webVariableTemplate .ddlWebVariableId').append($options);
    },
    bindLayoutElements: function (elements, currentLayoutElementId) {
        $("#rtDataObjectsBox option").remove();
        if (elements.length > 0) {
            var options = "";
            var types = Storyboard.Constants.itemTypeClearNames;
            for (var i = 0; i < elements.length; i++) {
                if (elements[i].layoutElementId != currentLayoutElementId) {
                    var title = types[elements[i].itemType].charAt(0).toUpperCase() + types[elements[i].itemType].slice(1) + ' box ' + elements[i].layoutElementId;
                    options += '<option value="' + elements[i].layoutElementId + '">' + title + '</option>';
                }
            }

            $("#rtDataObjectsBox").append(options);
        }
    },
    loadLayoutElements: function () {
        return Helpers.perfJSonCall({
            method: 'GetLayoutElementsAvailableForUpdate',
            service: 'RespondentTableSetup',
            message: locale.get('Loading layout elements'),
        });
    },
    loadFilters: function () {
        return window.IsFormReport ? null : ChartSetupProxy.GetFilters();
    },
    doesProjectHaveHFilters: function () {
        return Helpers.perfJSonCall({
            method: "ProjectHasHFilters",
            service: "GeneralSettings"
        });
    },
    bindFormReports: function (reports) {
        $("#ddlTargetFormReport option").remove();
        if (reports.length > 0) {
            $("#fsLinkToForm").show();

            var reportOptions = "";
            for (var report in reports)
                if (reports.hasOwnProperty(report)) {
                    reports[report].displayString = reports[report].displayString.substr(0, reports[report].displayString.length - 3);
                    reportOptions += '<option value="' + reports[report].reportId + '">' + reports[report].displayString + '</option>';
                }

            $("#ddlTargetFormReport").append(reportOptions);
        }
        else {
            $("#fsLinkToForm").hide();
        }
    },
    loadFormReports: function () {
        return Helpers.perfJSonCall({
            method: 'GetFormReports',
            service: 'RespondentTableSetup',
            message: locale.get('Loading form reports'),
            fixCasing: true
        });
    },
    loadRowsDefs: function (SelectedVariables) {
        if (SelectedVariables) {
            RespondentTableSetup.QsortSelVars(SelectedVariables);
            //preset options for drop down
            var decimalFormatArr = [];
            for (var i = 0; i < 10; i++) {
                decimalFormatArr[i] = "<option value='" + i + "'>" + i + " decimals" + "</option>";
            }
            var showAnswCodeArr = [];
            showAnswCodeArr[0] = "<option value='0'>Answer Text</option>";
            showAnswCodeArr[1] = "<option value='1'>Answer ID</option>";
            showAnswCodeArr[2] = "<option value='2'>Factor average</option>";

            var showSortByArr = [];
            showSortByArr[0] = "<option value='0'>Alphabetical</option>";
            showSortByArr[1] = "<option value='1'>Answer ID</option>";
            showSortByArr[2] = "<option value='2'>Sort order</option>";

            var showAnswOptionsArr = [];
            showAnswOptionsArr[0] = "<option value='0'>Display all answers</option>";
            showAnswOptionsArr[1] = "<option value='1'>Display original answers</option>";
            showAnswOptionsArr[2] = "<option value='2'>Display grouped answers</option>";
            //remove previous table
            $("#tblrtRowsdefs  .rtDataRow:not('.rtRowtemplate')").remove();
            //get row template
            var template = $("#tblrtRowsdefs  .rtRowtemplate");
            var table = $("#tblrtRowsdefs");
            template.show();
            //for (key in headers) {
            
            if (SelectedVariables) {
                SelectedVariables.forEach(function(sv) {
                    var filter = $(".rtRowtemplate").clone();
                    filter.removeClass("rtRowtemplate");
                    filter.find("#hdRownr").val(sv.Header.VariableId);
                    filter.find("#hdrtVarType").val(sv.Header.VariableType);
                    filter.find("#displheader").attr("checked", sv.Header.DisplayHeader);
                    filter.find("#useCustomHeader").change(function(event) {
                        if ($(event.currentTarget).is(':checked')) {
                            filter.find("#txtCustomHeader").removeAttr('disabled');
                        } else {
                            filter.find("#txtCustomHeader").attr('disabled', true);
                        }
                    });
                    filter.find("#useCustomHeader").attr("checked", sv.Header.UseCustomHeader);
                    filter.find("#chkShowByDefault").attr("checked", !sv.Header.HideByDefault);
                    filter.find("#txtCustomHeader").val(sv.Header.CustomHeader);
                    filter.find("#txtOrder").val(sv.Header.SortOrder);
                    filter.find("#allowFilter").attr("checked", sv.Header.AllowFilter);
                    filter.find("#chbShowThousandSeparator").attr("checked", sv.Header.ShowThousandSeparator);
                    filter.find("#hdrtShowDecimalFormat").val(sv.Header.DecimalFormat != null ? "1" : "0");
                    filter.find("#hdrtShowAnswerCode").val(sv.Header.ShowAnswerCode != null && sv.Header.VariableType > -1 ? "1" : "0");

                    if (sv.Header.DecimalFormat != null) {
                        filter.find("#ddlVariableFormat").append(decimalFormatArr.join('')).val(sv.Header.DecimalFormat);
                        filter.find("#ddlAnswerFormat").hide();
                        filter.find("#ddlSortBy").hide();
                    }
                    else if (sv.Header.ShowAnswerCode != null && sv.Header.VariableType > -1) {
                        filter.find("#ddlVariableFormat").append(showAnswCodeArr.join('')).val(sv.Header.ShowAnswerCode ? 1 : (sv.Header.ShowFactorAverage ? 2 : 0));
                        // In all newly created objects the default settings will be Display original answers
                        filter.find("#ddlAnswerFormat").append(showAnswOptionsArr.join('')).val(sv.Header.AnswerDisplayFormat == null ? 1 : sv.Header.AnswerDisplayFormat);
                        filter.find("#ddlSortBy").append(showSortByArr.join('')).val(sv.Header.SortBy == null ? 0 : sv.Header.SortBy);
                       if (sv.Header.EnableDisplayGroupedAnswersOption == null) {
                            RespondentTableSetup.setDisplayGroupedAnswersOptionVisibility(sv.QuestionID, filter);
                        } else if (!sv.Header.EnableDisplayGroupedAnswersOption) filter.find("#ddlAnswerFormat option:eq(2)").attr('disabled', 'disabled');
                        filter.find("#chbShowThousandSeparator").hide();
                    } else {
                        filter.find("#ddlSortBy").hide();
                        filter.find("#ddlVariableFormat").hide();
                        filter.find("#ddlAnswerFormat").hide();
                        filter.find("#chbShowThousandSeparator").hide();
                    }
                    table.append(filter);
                });
            }
            table.find('input.sortOrderEdit').each(function () {
                $(this).blur(function (evt) { RespondentTableSetup.bindRowsDefs(); });
            });
            template.hide();
        }
    },
    bindRowsDefs: function () {
        var selectedItems = $("#selectedVarBox option");
        var selVariables = [];
        //get selected variables already changed by user
        var userSelVariables = RespondentTableSetup.getSelectedVariables();
        selectedItems.each(function () {
            //get header default values from the cache
            var variable = RespondentTableSetup.getSelecetdVariablesFromCahce(this.value, userSelVariables);
            selVariables.push(variable);
        });

        if ((selVariables.filter(function (v) { return v.IsStacked; }).length > 0) && !($('#rblTablelayout_2').is(':checked'))) {
            $("#stackedDataLayoutSettings").show();
            if (!($('#rblStackedDataLayout_0').is(':checked')) && !($('#rblStackedDataLayout_1').is(':checked')))
                $('#rblStackedDataLayout_0').attr('checked', true);
        }
        else
            $("#stackedDataLayoutSettings").hide();

        RespondentTableSetup.loadRowsDefs(selVariables);
        RespondentTableSetup.toggleWebVariables(selVariables);
        //enable or disable custom header 
        $('#cbShowQuestionsCode').change();
    },
    bindRTSettings: function (settings) {
        //clear header definition table
        $("#tblrtRowsdefs  .rtDataRow:not('.rtRowtemplate')").remove();
        $("#resptabholder .invertBackground").hide();
        if (settings != undefined) {
            if (!settings.LayoutType) {
                $('#rblTablelayout_0').attr('checked', true);
            }
        }
        if (settings != undefined) {

            if (window.IsFormReport && settings.SettingId == 0)
                settings.LayoutType = 2;

            if (settings.SelectedVariables == null) {
                $('#selectedVarBox option').each(function (index, option) {
                    $(option).remove();
                });

            }
            else {
                settings.SelectedVariables.forEach(function (variable) {
                    variable.QuestionText = HTMLHelpers.htmlEncode(variable.QuestionText);
                    variable.aiIcon = variable.IsAICompute ? Storyboard.Constants.aiIconEntity : '';
                });
                HTMLHelpers.bindSelect($('#selectedVarBox'), settings.SelectedVariables, 'QuestionID', 'QuestionText', false, false, false, false, ["aiIcon", "Code", "QuestionText"]);
                $("#selectedVarBox option").each(function () {
                    var id = $(this).val();
                    var variable = Storyboard.RespondentTableCache.getVariableFromCache(id);
                    if (variable) {
                        $(this).attr('title', HTMLHelpers.htmlDecode(variable.QuestionText));
                    }
                });

                if ((settings.SelectedVariables.filter(function (v) { return v.IsStacked; }).length > 0) && !($('#rblTablelayout_2').is(':checked')))
                    $("#stackedDataLayoutSettings").show();
                else 
                    $("#stackedDataLayoutSettings").hide();

                RespondentTableSetup.loadRowsDefs(settings.SelectedVariables);
                RespondentTableSetup.toggleWebVariables(settings.SelectedVariables);

                if (settings.LayoutType == 0) {
                    $('#cbEnableSearch').hide().next().hide();
                }
            }

            $("#chbEnableLinkToForm").attr('checked', Boolean(settings.EnableLinkToForm));
            HTMLHelpers.setSelectedValuesOrFirst("#ddlLinkColumnPosition", settings.LinkColumnPosition);

            if (!settings.EnableLinkToForm) {
                $("#divLinkToForm").hide();
            } else {
                $("#divLinkToForm").show();
            }

            $('#rblTablelayout_0').attr('checked', (settings.LayoutType == 0));
            $('#rblTablelayout_1').attr('checked', (settings.LayoutType == 1));
            $('#rblTablelayout_2').attr('checked', (settings.LayoutType == 2));
            RespondentTableSetup.onTableLayoutChanged();

            if (!settings.StackedLayoutType || settings.StackedLayoutType === 0)
                $('#rblStackedDataLayout_0').attr('checked', true);

            $('#rblStackedDataLayout_0').attr('checked', (settings.StackedLayoutType == 1));
            $('#rblStackedDataLayout_1').attr('checked', (settings.StackedLayoutType == 2));

            //row type 2
            document.getElementById('cbFreezeHeaderRow').checked = Boolean(settings.FreezeHeaderRow);
            document.getElementById('cbHideQuestion').checked = Boolean(settings.HideEmptyQuewstion);
            document.getElementById('cbShowQuestionsCode').checked = Boolean(settings.ShowQuestionsCode);
            $('#cbShowQuestionsCode').change();

            document.getElementById('cbAllowFullScreenMode').checked = Boolean(settings.AllowFullScreenMode);
            document.getElementById('cbAllowExcelExport').checked = Boolean(settings.AllowExcelExport);
            document.getElementById('cbAllowCSVExport').checked = Boolean(settings.AllowCsvExport);

            document.getElementById('chkAllowToHideVariables').checked = Boolean(settings.AllowToHideVariables);

            $("#ddlRTSearchType").val(settings.SearchType);
            document.getElementById('chkSearchInHiddenColumns').checked = Boolean(settings.SearchInHiddenColumns);

			RespondentTableSetup.updateHideLowDataOptions();
			document.getElementById('cbHideLowRespOrData').checked = Boolean(settings.EnableHideLowData);
			$('#txtHideLowRespOrDataMessage').val(settings.HideLowDataMessage);
			RespondentTableSetup.setLowRespOrDataRules(settings.HideLowDataRules);
			RespondentTableSetup.showHideLowRespOrDataSettings();
			RespondentTableSetup.enableDisableLowDataRuleBtn();

			//$('#txtHideLowRespOrDataLimit').val(settings.HideLowDataSettings ? settings.HideLowDataSettings.HideLowDataLimit : '0');
			//HTMLHelpers.setSelectedValues('#ddlHideLowRespOrDataObject', settings.HideLowDataSettings ? settings.HideLowDataSettings.HideLowDataObject : -1);

            RespondentTableSetup.showHideSearchInHidden();
            RespondentTableSetup.showHideAllowSearch();
            RespondentTableSetup.showHideSortBy();
			RespondentTableSetup.showHideDisplayByDefault();

            var ddlDateFormat = document.getElementById('ddlDateFormat');
            if (settings.DateFormat == null || settings.DateFormat == "") {
                document.getElementById('ddlDateFormat').value = 0;
            } else {
                for (var i = 0; i < ddlDateFormat.children.length; i++) {
                    var option = ddlDateFormat.children[i];
                    if (option.text === settings.DateFormat) {
                        option.selected = true;
                        break;
                    }
                }
            }
            $("#txtrtRowsOnPage").val(settings.RowsOnPage);

            $("#rtTimeSelections").find(".tpcDropDown").val(settings.TimePeriod);
            if (settings.TimePeriod === 0)
                $("#rtTimeSelections").find(".tpcStartDateInput, .tpcStopDateInput").show();
            else
                $("#rtTimeSelections").find(".tpcStartDateInput, .tpcStopDateInput").hide();
            if (settings.TimePeriod === 27)
                $("#rtTimeSelections").find("#txtTimePeriod, #ddlTimePeriodSpan").show();
            else
                $("#rtTimeSelections").find("#txtTimePeriod, #ddlTimePeriodSpan").hide();

            if (settings.StartEndPeriod) {
                $("#rtTimeSelections").find(".dateInputStart").datepicker("setDate", Helpers.parseDate(settings.StartEndPeriod.StrStartDate));
                $("#rtTimeSelections").find(".dateInputStop").datepicker("setDate", Helpers.parseDate(settings.StartEndPeriod.StrStopDate));
            } else {
                $("#rtTimeSelections").find(".dateInputStart").datepicker("setDate", Helpers.strToDate($("#rtTimeSelections").find(".dateInputStart").attr("defaultdate")));
                $("#rtTimeSelections").find(".dateInputStop").datepicker("setDate", Helpers.strToDate($("#rtTimeSelections").find(".dateInputStop").attr("defaultdate")));
            }

            $("#rtTimeSelections").find("#txtTimePeriod").val(settings.TimePeriodSpanAmount);
            $("#rtTimeSelections").find("#ddlTimePeriodSpan").val(settings.TimePeriodSpan);

            document.getElementById('cbEnableSearch').checked = Boolean(settings.EnableSearch);
            document.getElementById('cbDisplayFilter').checked = Boolean(settings.DisplayFilter);
			$('#ddlDateVarRT').val(settings.DateVariableID === 0 ? $('#ddlDateVarRT').find('option[selected]').val() : settings.DateVariableID);

			$('#ddlSearchRowBgColorType').val(settings.SearchRowBgColorType);
			$('#fsSearchBgColor').toggle(settings.LayoutType == 0 && !settings.FreezeHeaderRow);

            RespondentTableSetup.setSelectedFilters(settings.Filters);
            RespondentTableSetup.setOptionalFilterSettings(settings.OptionalFilterSettings);
            RespondentTableSetup.initializeSortTemplate();
            RespondentTableSetup.initializeWebVariableTemplate();
            RespondentTableSetup.setSelectedSorting(settings.Sorting);
            RespondentTableSetup.setLinksToForm(settings.LinksToForm);
            RespondentTableSetup.setSelectedWebVariables(settings.WebVariables);
			if (window.IsFormReport) {
				RespondentTableSetup.setCustomerHistorySettings(settings.CustomerHistorySettings);
				RespondentTableSetup.showHideTimeSelections();
			}
            RespondentTableSetup.setThemesStyles(settings.TableStyles);
            if (settings.FilterCalcType != '0') {
                $("#ddlrtFilterCalcType").val(settings.FilterCalcType);
            }
            else {
                $("#ddlrtFilterCalcType").val($("#ddlrtFilterCalcType option:first").attr('value'));
            }
            $("#ddlrtFilterCalcType").change();
            if (settings.TableWidth === 0) {
                $("#rbrttableFit").attr('checked', true);
                $("#rbrttablecolumnwidth").attr('checked', false);
            }
            else {
                $("#rbrttableFit").attr('checked', false);
                $("#rbrttablecolumnwidth").attr('checked', true);
                $("#txtrtTableWidth").val(settings.TableWidth);

            }
            if ($("#ddlDateVarRT option").length <= 1)
                $(".rtDateVar").hide();
            else
                $(".rtDateVar").show();
            $("#rbrttableFit").change(); //call change for rbrttableFit for set disabled/enabled txtrtTableWidth edit box
            document.getElementById('cbDisplayTimePeriod').checked = Boolean(settings.DisplayTimePeriod);
            $("#txtrtFullScreenRowsOnPage").val(settings.FullScreenRowsOnPage);
            $("#txtrtFullScreenRowsOnPage").attr("disabled", !(settings.AllowFullScreenMode));

            RespondentTableSetup.SetSVSubsets(settings.VariableSubsets);

            if (settings.FormattingRulesIds && settings.FormattingRulesIds.length > 0)
                $("#respFormatRulesIds").val(settings.FormattingRulesIds.join(','));
            else
                $("#respFormatRulesIds").val("");

            HTMLHelpers.setSelectedValues('#rtDataObjectsBox', settings.LayoutElementsToUpdate);
        }
    },
    setCustomerHistorySettings: function (customerHistorySettings) {
        document.getElementById("chkEnableCustomerHistory").checked = customerHistorySettings ? Boolean(customerHistorySettings.IsEnabled) : false;
        $(".fsCustomerHistory").css("display", $("#chkEnableCustomerHistory").is(":checked") ? "" : "none");
        document.getElementById("chbUseHFilterRights").checked = customerHistorySettings ? Boolean(customerHistorySettings.UseHFilterAccessRights) : false;
        $("#ddlClientIdVariable").val(customerHistorySettings ? customerHistorySettings.QuestionId : $("#ddlClientIdVariable option:first").val());
    },
    setOptionalFilterSettings: function (optionalFilterSettings) {
        $(".chkOptFilterRT, #chkOptVariableSubsetRT, #chkOptHFilterRT, #chkOptTimePeriodRT, #chkOptDateVariableRT").attr('checked', true);

        if (optionalFilterSettings) {
            optionalFilterSettings.forEach(function(fs) {
                if (!fs.OptionalSettingType) return;
                if (fs.OptionalSettingType == 1) {
                    $("#chkOptVariableSubsetRT").attr("checked", fs.IsApply);
                }
                else if (fs.OptionalSettingType == 2) {
                    $("#chkOptHFilterRT").attr("checked", fs.IsApply);
                }
                else if (fs.OptionalSettingType == 3) {
                    RespondentTableSetup.setOptionalFilterQuestions(fs.QuestionID, fs.IsApply);
                }
                else if (fs.OptionalSettingType == 4) {
                    $("#chkOptTimePeriodRT").attr("checked", fs.IsApply);
                    $("#chkOptDateVariableRT").attr("checked", fs.IsApplyDateVariable);
                }
            });
        }

        var allChecked = $('#optionalFilterSettingsRT input[type="checkbox"]')
            .filter(function() { return $(this).attr('id') !== 'chkOptFilter'; })
            .filter(function() { return !$(this).is(':checked'); })
            .length === 0;

        $('#optionalFilterSettingsRT')
            .prev('.optionalFilterSettingsCheckAll').find('input[type="checkbox"]')
            .attr('checked', allChecked);
    },
    setOptionalFilterQuestions: function (questionId, isApply) {
        $("#optFilterBoxRT div").each(function () {
            if (questionId == parseInt($(this).find("#hidOptQuestionId").val() || "0")) {
                $(this).find(".chkOptFilterRT").attr("checked", isApply);
            }
        });
    },
    getRespondentTableSettingsData: function (layoutElementGuid) {
        var data = {};
        if (layoutElementGuid != undefined && layoutElementGuid != "") {
            var le = Storyboard.LayoutDesigner.getLayoutElementByGuid(layoutElementGuid);
            var leItem = Storyboard.LayoutDesigner.getElementItemByType(Storyboard.Constants.itemTypes.RESPONDENTTABLE, le);
            data.LayoutElementItemGuid = leItem.guid;
            // will be set to the layoutElementId on the server side
            data.SettingId = leItem.layoutElementId;
        } else {
            // preview mode
            data.LayoutElementItemGuid = "";
            data.SettingId = 0;
        }

        data.SelectedVariables = RespondentTableSetup.getSelectedVariables();

        var selVariables = [];
        var selectedItems = $("#selectedVarBox option");
        //add IsStacked info from the cache
        selectedItems.each(function () {
            var variable = RespondentTableSetup.getSelecetdVariablesFromCahce(this.value, data.SelectedVariables);
            selVariables.push(variable);
        });

        if (data.SelectedVariables.length == 0) {
            // if no selected variables found, try to get settings from the cache
            var respondentTablesettings = Storyboard.RespondentTableCache.getSettingsFromCache(data.LayoutElementItemGuid);
            if (respondentTablesettings != undefined && respondentTablesettings != null) {
                return respondentTablesettings;
            }
        }

        data.TimePeriod = RespondentTableSetup.getTimePeriod().timePeriod;
        data.TimePeriodSpan = RespondentTableSetup.getTimePeriod().timePeriodSpan;
        data.TimePeriodSpanAmount = RespondentTableSetup.getTimePeriod().timePeriodSpanAmount;
        data.StartEndPeriod = RespondentTableSetup.getStartEndPeriod();
        data.LayoutType = RespondentTableSetup.getLayoutType();
        data.StackedLayoutType = selVariables.filter(function (v) { return v.IsStacked; }).length > 0 ? RespondentTableSetup.getStackedLayoutType() : 0;
        data.HideEmptyQuewstion = RespondentTableSetup.getHideEmptyQuewstion();
        data.AllowFullScreenMode = RespondentTableSetup.getAllowFullScreenMode();
        data.AllowExcelExport = RespondentTableSetup.getAllowExcelExport();
        data.AllowCsvExport = $('#cbAllowCSVExport').is(":checked");
        data.AllowToHideVariables = $('#chkAllowToHideVariables').is(":checked");
        data.DateFormat = RespondentTableSetup.getDateFormat();
        data.EnableSearch = RespondentTableSetup.getEnableSearch();
        data.DisplayFilter = RespondentTableSetup.getDisplayFilter();
        data.Filters = RespondentTableSetup.getFilters();
        data.TableStyles = RespondentTableSetup.getStyles();
        data.ShowQuestionsCode = RespondentTableSetup.getShowQuestionsCode();
        data.RowsOnPage = RespondentTableSetup.getRowsOnPage();
        data.FilterCalcType = RespondentTableSetup.getFilterCalcType();
        data.DateVariableID = $('#ddlDateVarRT').val() || 1;
        data.TableWidth = RespondentTableSetup.getTableWidth();
        data.DisplayTimePeriod = RespondentTableSetup.getDisplayTimePeriod();
        data.FullScreenRowsOnPage = RespondentTableSetup.getFullScreenRowsOnPage();
        data.VariableSubsets = RespondentTableSetup.getVarSubs();
        data.Sorting = RespondentTableSetup.getSorting();
        data.WebVariables = RespondentTableSetup.getWebVariables();
        data.LinksToForm = RespondentTableSetup.getLinksToForm();
		data.OptionalFilterSettings = RespondentTableSetup.getOptionalFilterSetting(data.SettingId);
		data.FreezeHeaderRow = $('#cbFreezeHeaderRow').is(':checked');
		data.SearchRowBgColorType = $('#ddlSearchRowBgColorType').val() || 1;

		data.EnableHideLowData = $('#cbHideLowRespOrData').is(':checked');
		data.HideLowDataMessage = $('#txtHideLowRespOrDataMessage').val();
		data.HideLowDataRules = RespondentTableSetup.getLowRespOrDataRules();

        if (window.IsFormReport)
            data.CustomerHistorySettings = RespondentTableSetup.getCustomerHistorySettings();

        data.EnableLinkToForm = $("#chbEnableLinkToForm").is(":checked");
        data.LinkColumnPosition = $("#ddlLinkColumnPosition").val() || 1;

        data.SearchType = $("#ddlRTSearchType").val();
        data.SearchInHiddenColumns = $("#chkSearchInHiddenColumns").is(":checked");

        data.FormattingRulesIds = RespondentTableSetup.getFormatRules();

        var elementsIds = [];
        $('#rtDataObjectsBox option:selected').each(function () { elementsIds.push($(this).val()); });
        data.LayoutElementsToUpdate = elementsIds;

        return data;
	},
	getHideLowDataSettings: function () {
		return {
			EnableHideLowData: $('#cbHideLowRespOrData').attr('checked'),
			HideLowDataLimit: $('#txtHideLowRespOrDataLimit').val(),
			HideLowDataObject: $('#ddlHideLowRespOrDataObject').val(),
			HideLowDataMessage: $('#txtHideLowRespOrDataMessage').val()
		};
	},
    getCustomerHistorySettings: function () {
        return {
            IsEnabled: $("#chkEnableCustomerHistory").attr("checked"),
            QuestionId: $("#ddlClientIdVariable").val(),
            UseHFilterAccessRights: $("#chbUseHFilterRights").attr("checked")
        };
    },
    getFormatRules: function () {
        var rulesIds = [];
        if ($("#respFormatRulesIds").val()) {
            rulesIds = $("#respFormatRulesIds").val().split(',');
            for (var i = 0; i < rulesIds.length; i++) {
                rulesIds[i] = parseInt(rulesIds[i], 10);
            }
        }
        return rulesIds;
    },
    getOptionalFilterSetting: function (settingId) {
        var optFilterSettings = [];
        var rowVS = new Object();
        rowVS.SettingId = parseInt(settingId || "0");
        rowVS.OptionalSettingType = 1;
        rowVS.IsApply = $("#chkOptVariableSubsetRT").is(':checked');
        optFilterSettings.push(rowVS);

        var rowHFilter = new Object();
        rowHFilter.SettingId = parseInt(settingId || "0");
        rowHFilter.OptionalSettingType = 2;
        rowHFilter.IsApply = $("#chkOptHFilterRT").is(':checked');
        optFilterSettings.push(rowHFilter);

        $("#optFilterBoxRT div").each(function () {
            var rowFilter = new Object();
            rowFilter.SettingId = parseInt(settingId || "0");
            rowFilter.FilterID = parseInt($(this).find("#hidOptFilterId").val() || "0");
            rowFilter.QuestionID = parseInt($(this).find("#hidOptQuestionId").val() || "0");
            rowFilter.OptionalSettingType = 3;
            rowFilter.IsApply = $(this).find('.chkOptFilterRT').is(':checked');
            if (rowFilter.FilterID > 0)
                optFilterSettings.push(rowFilter);
        });

        var rowTimePeriod = new Object();
        rowTimePeriod.SettingId = parseInt(settingId || "0");
        rowTimePeriod.OptionalSettingType = 4;
        rowTimePeriod.IsApply = $("#chkOptTimePeriodRT").is(':checked');
        rowTimePeriod.IsApplyDateVariable = $("#chkOptDateVariableRT").is(':checked');
        optFilterSettings.push(rowTimePeriod);

        return optFilterSettings;
    },
    getVarSubs: function () {
        return $('#lbrtVS').val() || [];
    },
    getFilterCalcType: function () {
        return $('#ddlrtFilterCalcType  option:selected').val();
    },
    getSelectedVariables: function () {
        var variables = [];
        var selQuest = $('#selectedVarBox option');
        selQuest.each(function () {
            var variable = {};
            variable.AnswerBlockID = 0;
            variable.QuestionID = this.value;
            variable.QuestionText = this.text;
            variable.QuestionT = 0;
            variable.IsReportActive = false;
            variable.Answers = [];
            variable.Header = RespondentTableSetup.getHeader(this.value);
            variables.push(variable);
        })
        RespondentTableSetup.QsortSelVars(variables);
        return variables;
    },
    getTimePeriod: function () {
        var timePeriod = {};
        timePeriod.timePeriod = $("#rtTimeSelections").find(".tpcDropDown").val() || 0;
        timePeriod.timePeriodSpan = $("#rtTimeSelections").find("#ddlTimePeriodSpan").val() || 1;
        timePeriod.timePeriodSpanAmount = $("#rtTimeSelections").find("#txtTimePeriod").val() || 0;
        return timePeriod;
    },
    getStartEndPeriod: function () {
        var timeStartEnd = {};
        if ($("#rtTimeSelections").find('.dateInputStart').length) {
            timeStartEnd.startDate = Helpers.formatDate($("#rtTimeSelections").find('.dateInputStart').datepicker('getDate'));
            timeStartEnd.stopDate = Helpers.formatDate($("#rtTimeSelections").find('.dateInputStop').datepicker('getDate'));
        }
        return timeStartEnd;
    },
    getLayoutType: function () {
        var lt = $('#rblTablelayout_0').is(':checked') ? 0 : 1;
        if ((lt == 1) && $('#rblTablelayout_2').is(':checked')) {
            lt = 2;
        }
        return lt;
    },
    getStackedLayoutType: function() {
        return $('#rblStackedDataLayout_1').is(':checked') ? 2 : 1;
    },
    getHideEmptyQuewstion: function () {
        return $("#cbHideQuestion").is(':checked');
    },
    getShowQuestionsCode: function () {
        return $("#cbShowQuestionsCode").is(':checked');
    },
    getAllowFullScreenMode: function () {
        return $("#cbAllowFullScreenMode").is(':checked');
    },
    getAllowExcelExport: function () {
        return $("#cbAllowExcelExport").is(':checked');
    },
    getRowsOnPage: function () {

        var rowsPageVal = $("#txtrtRowsOnPage").val();
        var result = parseInt(rowsPageVal);
        if (isNaN(result)) {
            result = 50;
        }
        return result;
    },
    getFullScreenRowsOnPage: function () {
        var rowsPageVal = $("#txtrtFullScreenRowsOnPage").val();
        var result = parseInt(rowsPageVal);
        if (isNaN(result)) {
            result = 50;
        }
        return result;
    },
    getDateFormat: function () {
        return $("#ddlDateFormat option:selected").text();
    },
    getEnableSearch: function () {
        return $("#cbEnableSearch").is(':checked');
    },
    getTableWidth: function () {
        var lt = $('#rbrttableFit').is(':checked') ? 0 : 1;
        if (lt == 1) {
            var pixval = $("#txtrtTableWidth").val();
            var i = parseInt(pixval);
            if (!isNaN(i)) {
                lt = i;
            }
        }
        return lt;
    },
    getDisplayFilter: function () {
        return $('#cbDisplayFilter').is(':checked');
    },
    getDisplayTimePeriod: function () {
        return $('#cbDisplayTimePeriod').is(':checked');
    },
    getHeader: function (variableId) {
        var defRows = $("#tblrtRowsdefs  .rtDataRow:not('.rtRowtemplate')");
        var Header = {};
        defRows.each(function () {
            if ($(this).find("#hdRownr").val() == variableId) {
                Header.DisplayHeader = $(this).find("#displheader").is(':checked');
                Header.AllowFilter = $(this).find("#allowFilter").is(':checked');
                Header.ShowThousandSeparator = $(this).find("#chbShowThousandSeparator").is(":checked");
                Header.UseCustomHeader = $(this).find("#useCustomHeader").is(':checked');
                var int_val = parseInt($(this).find("#txtOrder").val());
                //convert to int for correct sorting
                if (isNaN(int_val)) {
                    int_val = 0;
                }
                Header.SortOrder = int_val;
                Header.CustomHeader = $(this).find("#txtCustomHeader").val();
                Header.HFilterId = null;
                Header.VariableId = variableId;
                Header.VariableType = $(this).find("#hdrtVarType").val();
                Header.HideByDefault = !$(this).find("#chkShowByDefault").is(':checked');
                var IsShowDecimalFormat = $(this).find("#hdrtShowDecimalFormat").val() == "1" ? true : false;
                var IsshowAnswerCode = $(this).find("#hdrtShowAnswerCode").val() == "1" ? true : false;
                //categorial question
                if (IsshowAnswerCode && Header.VariableType > -1) {
                    Header.DecimalFormat = null;
                    Header.ShowAnswerCode = $(this).find("#ddlVariableFormat").val() == "1" ? true : false;
                    Header.ShowFactorAverage = $(this).find("#ddlVariableFormat").val() == "2" ? true : false;
                    Header.AnswerDisplayFormat = $(this).find("#ddlAnswerFormat").val();
                    Header.EnableDisplayGroupedAnswersOption = $(this).find("#ddlAnswerFormat option:eq(2)").is(':disabled'); 
                    Header.SortBy = $(this).find("#ddlSortBy").val();
                } else
                    //open numeric question
                    if (IsShowDecimalFormat) {
                        Header.DecimalFormat = $(this).find("#ddlVariableFormat").val();
                        Header.ShowAnswerCode = null;
                        Header.ShowFactorAverage = null;
                       }

                return Header;
            }
        });
        return Header;
    },
    getFilters: function () {
        var filters = [];

        $("#rtFilterBox > div:not(.rtfilterboxTemplate)").each(function () {
            var filterId = $(this).find("#hidFilterId").val();
            var questionId = $(this).find('#hidQuestionId').val();
            var allAnswers = $(this).find("select option[value='all']:selected").length > 0;

            var selectedAnswers = $(this).find(allAnswers ? "select option" : "select option:selected").
                filter(function () { return $(this).val() != "0" && $(this).val() != "all"; }).
                map(function () {
                    return { answerId: $(this).val(), answerText: $(this).text() };
                }).toArray();

            var isCompare = $(this).find("#chkCompare").attr("checked");
            var filterText = $(this).find('h3').text();

            if ($(selectedAnswers).length > 0) {
                var Filter = {
                    FilterID: filterId,
                    Answers: selectedAnswers,
                    Compare: isCompare,
                    QuestionID: questionId,
                    FilterText: filterText,
                    AllAnswers: allAnswers
                };

                filters.push(Filter);
            }
        });

        return filters;
    },
    getSorting: function () {
        var values = [];

        $('#sortCriteriaContainer div').each(function () {
            var questionId = $(this).find('.ddlSortCriteria option:selected').val();

            var Sorting = {
                QuestionId: questionId,
                SortingOrder: $(this).find('.ddlSortOrder option:selected').val()
            };

            values.push(Sorting);

        });
        return values;
    },
    getWebVariables: function () {
        var values = [];

        $('#webVariableContainer > div').each(function () {
            var questionId = $(this).find('.ddlWebVariableId option:selected').val();
            var thumbnailHeight = $(this).find('.webVariableThumbnailHeight').val();
            var linkText = $(this).find('.webVariableLinkText').val();

            var webVariable = {
                QuestionId: questionId,
                VariableType: $(this).find('.ddlVariableType option:selected').val(),
                ThumbnailHeight: thumbnailHeight ? thumbnailHeight : 0,
                LinkText: linkText.length > 0 ? linkText : ''
            };

            if (questionId > 0)
                values.push(webVariable);
        });

        return values;
    },
    getLinksToForm: function () {
        var values = [];

        $('#linksToFormContainer div').each(function () {
            var link = {
                Id: $(this).find('#hdnLinkToFormId').val() || 0,
                TargetFormId: $(this).find('#ddlTargetFormReport').val() || 0,
                LinkColumnHeader: $(this).find('#txtLinkColumnHeader').val() || "",
                LinkButtonText: $(this).find('#txtLinkButtonLabel').val() || ""
            };

            values.push(link);
        });

        return values;
	},
	getLowRespOrDataRules: function () {
		var rules = [];

		$('#divLowRespOrDataRulesContainer div').each(function () {
			var rule = {
				Limit: $(this).find('#txtHideLowRespOrDataLimit').val() || 0,
				Object: $(this).find('#ddlHideLowRespOrDataObject').val() || -1
			};

			rules.push(rule);
		});

		return rules;
	},
    getSelecetdVariablesFromCahce: function (id, selectedVariables) {
        if (selectedVariables.length > 0) {
            var selVar = [];
            for (var idx in selectedVariables) {
                if (selectedVariables[idx].QuestionID === id) {
                    selVar = selectedVariables[idx];
                    break;
                }
            }
            var availVar = Storyboard.RespondentTableCache.getVariableFromCache(id);
            if (availVar != undefined) {
                if (selVar.Header.VariableId == undefined) {
                    //if no header defined yet for selected variable, set header from available variable
                    selVar.Header = availVar.Header;
                }
                //Copy only variable type, DecimalFormat, and AnswerCode from the available variable if not defined
                else {
                    if (selVar.Header.VariableType == undefined) {
                        selVar.Header.VariableType = availVar.Header.VariableType;
                    }
                    if (selVar.Header.DecimalFormat == undefined) {
                        selVar.Header.DecimalFormat = availVar.Header.DecimalFormat;
                    }
                    if (selVar.Header.ShowAnswerCode == undefined) {
                        selVar.Header.ShowAnswerCode = availVar.Header.ShowAnswerCode;
                    }
                }
                selVar.IsStacked = availVar.IsStacked;
            }
            return selVar;
        }
        else {
            return Storyboard.RespondentTableCache.getVariableFromCache(id);
        }
    },
    setVaraibleToCache: function (variable, id) {
        Storyboard.RespondentTableCache.setVariableToCache(variable, id);
    },
    setSelectedFilters: function (filterArray) {
        HTMLHelpers.setSelectedValues($("#rtFilterBox div select"), 0);

        if (filterArray) {
            filterArray.forEach(function(filter) {
                if (!filter.FilterID) return;
                var filterbox = $("#rtFilterBox div #hidFilterId[value='" + filter.FilterID + "']").parent();

                if (filter.AllAnswers)
                    HTMLHelpers.setSelectedValues(filterbox.find('select'), "all");
                else {
                    var answerIds = $.map(filter.Answers, function (e) { return isNaN(e.AnswerID) ? e : e.AnswerID });
                    HTMLHelpers.setSelectedValues(filterbox.find('select'), answerIds);
                }
            });
        }
    },
    setSelectedSorting: function (sorting) {
        $('#sortCriteriaContainer').empty();

        if (sorting) {
            sorting.forEach(function(s) {
                var $sortTemplate = $('#sortCriteriaTemplate div').clone();
                $('#sortCriteriaContainer').append($sortTemplate);
                $('#sortCriteriaContainer div').last().find('.ddlSortCriteria').val(s.QuestionId);
                $('#sortCriteriaContainer div').last().find('.ddlSortOrder').val(s.SortingOrder);
            });
        }

        if ($('#sortCriteriaContainer div').length === 0) {
            var $sortTemplate = $('#sortCriteriaTemplate div').clone();
            $('#sortCriteriaContainer').append($sortTemplate);
        }

        $('#sortCriteriaContainer div').first().find('.deleteSortCriteria').remove();
    },
    setSelectedWebVariables: function (webVariables) {
        $('#webVariableContainer').empty();

        if (webVariables) {
            webVariables.forEach(function(wv) {
                var $webVariableTemplate = $('#webVariableTemplate > div').clone();
                Helpers.setupIntegerInput($webVariableTemplate.find('.webVariableThumbnailHeight'), 3, true);

                $webVariableTemplate.find('.ddlWebVariableId').val(wv.QuestionId);
                $webVariableTemplate.find('.ddlVariableType').val(wv.VariableType);
                $webVariableTemplate.find('.webVariableThumbnailOption').toggle(wv.VariableType === 1);
                $webVariableTemplate.find('.webVariableLinkOption').toggle(wv.VariableType === 2);
                $webVariableTemplate.find('.clearImageCache').closest('.settingItem').toggle(wv.VariableType === 1);
                $webVariableTemplate.find('.webVariableThumbnailHeight').val(wv.ThumbnailHeight);
                $webVariableTemplate.find('.webVariableLinkText').val(wv.LinkText);

                $('#webVariableContainer').append($webVariableTemplate);
            });
        }
    },
    setLinksToForm: function (links) {
        $('#linksToFormContainer').empty();

        if (links) {
            links.forEach(function(link) {
                var linkTemplate = $('#linkToFormTemplate div').clone();
                linkTemplate.find('#hdnLinkToFormId').val(link.Id);
                linkTemplate.find('#ddlTargetFormReport').val(link.TargetFormId);
                linkTemplate.find('#txtLinkColumnHeader').val(link.LinkColumnHeader);
                linkTemplate.find('#txtLinkButtonLabel').val(link.LinkButtonText);

                $('#linksToFormContainer').append(linkTemplate);
            });
        }
    },
    setLowRespOrDataRules: function (rules) {
        $('#divLowRespOrDataRulesContainer').empty();

        if (rules) {
            rules.forEach(function(rule) {
                var ruleTemplate = $('#rtHideLowRespRuleTemplate > div').clone();
                ruleTemplate.find('#txtHideLowRespOrDataLimit').val(rule.Limit);
                HTMLHelpers.setSelectedValues(ruleTemplate.find('#ddlHideLowRespOrDataObject'), rule.Object);

                $('#divLowRespOrDataRulesContainer').append(ruleTemplate);
            });
        }
        RespondentTableSetup.hideShowDuplicateOptions();
    },
    bindThemesList: function (themeArray) {
        $('#RespTableThemesTemplateList').empty();
        for (var index in themeArray)
            if (themeArray.hasOwnProperty(index)) {

                var theme = $('<div class="ThemePreview"><img src="' + Storyboard.Constants.respondentTableTemplateImageFolderPath + themeArray[index].ThemeId + '.png" alt="' + themeArray[index].ThemeName + '" title="' + themeArray[index].ThemeName + '" themeID="' + themeArray[index].ThemeId + '" /></div>')
                    .click(function (evt) {
                        evt.preventDefault();
                        evt.stopPropagation();
                        //Storyboard.LayoutControls.showLoadingBar('Applying template style...');
                        RespondentTableSetup.getRTThemeStyles($(evt.target).attr('themeID'), function (styles) {
                            RespondentTableSetup.setThemesStyles(styles);
                            Storyboard.LayoutControls.hideLoadingBar();
                        });
                    });
                $('#RespTableThemesTemplateList').append(theme);
            }
    },
    loadThemesList: function (howMany) {
        Helpers.perfJSonCall({
            method: "GetRespondentTableThemesList",
            data: { themesCount: howMany },
            successCallback: function (res) {
                RespondentTableSetup.bindThemesList(res);
                Storyboard.Dependency.complete('RESPONDENTTABLESETUP', 'themes');
            },
            service: 'RespondentTableSetup',
            fixCasing: false
        });
    },
    getRTThemeStyles: function (themeID, callback) {
        var data = {
            themeID: themeID
        };
        Helpers.perfJSonCall({
            method: "GetRespondentTableThemeStyles",
            data: data,
            service: 'RespondentTableSetup',
            successCallback: callback,
            fixCasing: false
        });
    },
    loadStylesForLayoutElement: function (layoutElement, optCallback) {
        var me = this;
        var data = { layoutElement: layoutElement };
        Helpers.perfJSonCall({
            method: "GetRespondentTableStyles", data: data, successCallback: function (stylesArr) {

                if (!stylesArr.length) {
                    var theme = SimpleTableStyle.getTemplates()[0].theme;
                    var defaultFont = Storyboard.LayoutDesigner.getDefaultFont();
                    stylesArr = $.map(theme.styles, function (style) {

                        var keyval = style.split('|');
                        if (keyval[0] === "ans_font" || keyval[0] === "first_row_font" || keyval[0] === "first_column_font")
                            keyval[1] = defaultFont.Family;
                        return { SettingKey: keyval[0], SettingValue: keyval[1] };
                    });
                }

                me.setThemesStyles(stylesArr);

                if (optCallback)
                    optCallback();
            }
        });
    },

    saveStylesForLayoutElement: function (layoutElement, callback) {
        var data = {
            layoutElement: layoutElement,
            styles: this.getStyles()
        };
        Helpers.perfJSonCall({
            method: "SaveRespondentTableStyles",
            data: data,
            successCallback: function () { if (callback) callback(); }
        });
    },
    setDefaultStyles: function () {
        $('#rt_bgcolor1').attr('style', 'background-color: rgb(220, 228, 241); color: rgb(220, 228, 241);').attr('title', '#dce4f1');
        $('#rt_bgcolor2').attr('style', 'background-color: rgb(255, 255, 255); color: rgb(255, 255, 255);').attr('title', '#ffffff');
        $('#rt_ans_font option').each(function () { $(this).removeAttr('selected'); });
        $('#rt_ans_font option:first').attr('selected', 'selected');
        $('#rt_ans_fontsize option').each(function () { $(this).removeAttr('selected'); });
        $('#rt_ans_fontsize option:eq(5)').attr('selected', 'selected');
        $('#rt_warning_fontsize option').each(function () { $(this).removeAttr('selected'); });
        $('#rt_warning_fontsize option:eq(5)').attr('selected', 'selected');
        $('#rt_filter_info_fontsize option').each(function () { $(this).removeAttr('selected'); });
        $('#rt_filter_info_fontsize option:eq(5)').attr('selected', 'selected');
        $('#rt_first_row_fontsize option').each(function () { $(this).removeAttr('selected'); });
        $('#option:eq(5)').attr('selected', 'selected');
        $('#rt_first_column_fontsize option').each(function () { $(this).removeAttr('selected'); });
        $('#option:eq(5)').attr('selected', 'selected');
        $('#rt_ans_fontcolor').attr('style', 'background-color: rgb(0, 0, 0); color: rgb(0, 0, 0);').attr('title', '#000000');
        $('#rt_warning_fontcolor').attr('style', 'background-color: rgb(0, 0, 0); color: rgb(0, 0, 0);').attr('title', '#000000');
        $('#rt_filter_info_fontcolor').attr('style', 'background-color: rgb(0, 0, 0); color: rgb(0, 0, 0);').attr('title', '#000000');
        $('.settingsFieldsetContent input:checkbox').attr('checked', false);
        $('.settingsFieldsetContent input:radio').attr('checked', false).change();
        $('#rt_ans_textalignment option').each(function () { $(this).removeAttr('selected'); });
        $('#rt_ans_textalignment option:first').attr('selected', 'selected');
        $('#rt_ans_verticaltextalignment option').each(function () { $(this).removeAttr('selected'); });
        $('#rt_ans_verticaltextalignment option:eq(1)').attr('selected', 'selected');
        $('#rt_bordercolor').attr('style', 'background-color: rgb(255, 255, 255); color: rgb(255, 255, 255);').attr('title', '#ffffff');
        $('#rt_cell_bordercolor').attr('style', 'background-color: rgb(255, 255, 255); color: rgb(255, 255, 255);').attr('title', '#ffffff');
        $('#rt_first_row_bgcolor').attr('style', 'background-color: rgb(255, 255, 255); color: rgb(255, 255, 255);').attr('title', '#ffffff');
        $('#rt_first_row_uneven_bgcolor').attr('style', 'background-color: rgb(220, 228, 241); color: rgb(220, 228, 241);').attr('title', '#dce4f1')
        $('#rt_first_row_bordercolor').attr('style', 'background-color: rgb(255, 255, 255); color: rgb(255, 255, 255);').attr('title', '#ffffff');
        $('#rt_first_column_bgcolor').attr('style', 'background-color: rgb(255, 255, 255); color: rgb(255, 255, 255);').attr('title', '#ffffff');
        $('#rt_first_column_uneven_bgcolor').attr('style', 'background-color: rgb(220, 228, 241); color: rgb(220, 228, 241);').attr('title', '#dce4f1')
        $('#rt_first_column_bordercolor').attr('style', 'background-color: rgb(255, 255, 255); color: rgb(255, 255, 255);').attr('title', '#ffffff');
        $('#rt_first_row_fontcolor').attr('style', 'background-color: rgb(0, 0, 0); color: rgb(0, 0, 0);').attr('title', '#000000');
        $('#rt_first_column_fontcolor').attr('style', 'background-color: rgb(0, 0, 0); color: rgb(0, 0, 0);').attr('title', '#000000');
        
        $('#rt_filter_info_bgcolor').attr('style', 'background-color: rgb(255, 255, 255); color: rgb(255, 255, 255);').attr('title', '#ffffff');
        $('#rt_borderwidth option').each(function () { $(this).removeAttr('selected'); });
        $('#rt_borderwidth option:first').attr('selected', 'selected');
        $('#rt_cell_borderwidth option').each(function () { $(this).removeAttr('selected'); });
        $('#rt_cell_borderwidth option:first').attr('selected', 'selected');
        $('#rt_first_row_borderwidth option').each(function () { $(this).removeAttr('selected'); });
        $('#rt_first_row_borderwidth option:first').attr('selected', 'selected');
        $('#rt_first_column_borderwidth option').each(function () { $(this).removeAttr('selected'); });
        $('#rt_first_column_borderwidth option:first').attr('selected', 'selected');
        $('.ChartStyleDashStyleValue').show();
        $('#rt_first_row_textalignment option').each(function () { $(this).removeAttr('selected'); });
        $('#rt_first_row_textalignment option:first').attr('selected', 'selected');
        $('#rt_first_row_verticaltextalignment option').each(function () { $(this).removeAttr('selected'); });
        $('#rt_first_row_verticaltextalignment option:eq(1)').attr('selected', 'selected');
        $('#rt_first_column_textalignment option').each(function () { $(this).removeAttr('selected'); });
        $('#rt_first_column_textalignment option:first').attr('selected', 'selected');
        $('#rt_warning_textalignment option').each(function () { $(this).removeAttr('selected'); });
        $('#rt_warning_textalignment option:last').attr('selected', 'selected');
        $('#rt_filter_info_textalignment option').each(function () { $(this).removeAttr('selected'); });
        $('#rt_filter_info_textalignment option:first').attr('selected', 'selected');
        $('#rt_first_column_verticaltextalignment option').each(function () { $(this).removeAttr('selected'); });
        $('#rt_first_column_verticaltextalignment option:eq(1)').attr('selected', 'selected');
        $('.ChartStyleDashStyleValue').removeAttr("data-value").css("background-image", "none");
        $('.ChartStyleDashStyleValue').removeAttr("data-value").css("background-image", "none");
        $('#rblTablelayout_0').attr('checked', true).change();
        $('#rblStackedDataLayout_0').attr('checked', true);
        $('#ddltpcTimePeriod').val('20').change();
        $('#ddlDateFormat').val('0').change();
        //padding and line height
        $('#rt_cell_autopadding').attr('checked', false);
        $('#rt_cell_autoheight').attr('checked', true);
        $('#chbUseFullWidth').attr('checked', true);
        $('#chbUseFullHeight').attr('checked', false);
        $('#rt_cell_padding').val('4');
        $('#rt_cell_height').val('0');

        //width
        $('#rt_first_row_autowidth').attr('checked', true);
		$('#rt_first_row_maxwidth').val('');

		$('#ddlSearchRowBgColorType').val(1);
    },
	setThemesStyles: function (styleArray, isChartCreator) {
		var prefix = isChartCreator ? 'cc_rt_' : 'rt_';
        if (styleArray == null || styleArray.length == 0) {
            //try to load default theme (with ID==0) from the server
            //Storyboard.LayoutControls.showLoadingBar('Applying default template style...');
            RespondentTableSetup.getRTThemeStyles(0, function (styles) {
                styleArray = styles;
                Storyboard.LayoutControls.hideLoadingBar();
                if (styleArray.length == 0) {
                    RespondentTableSetup.setDefaultStyles();
                }
                else {
                    RespondentTableSetup.setThemesStyles(styleArray);
                }
            });
        }
        else {
            $(styleArray).each(function (index) {
                var settingKey = this.SettingKey;
				var selector = '#' + prefix + this.SettingKey;
				if (isChartCreator && settingKey == 'ans_font')
                    selector = '#cc_chartstyle_chart_style_fontFamily';

                if (isChartCreator && settingKey == 'filter_info_fontcolor')
                    selector = '#cc_chartstyle_title_style_color';
                if (isChartCreator && settingKey == 'filter_info_fontsize')
                    selector = '#cc_chartstyle_title_style_fontSize';

				var elem = selector.replace('_colorPlaceholderId', '');

                var color, colorId;

                if ($(elem).is('input:text')) {
                    if ($(elem).hasClass('colorpicker-target')) {
                        // Colorpicker
                        if (~settingKey.indexOf('_colorPlaceholderId')) {
                            colorId = this.SettingValue;
                            color = styleArray.filter(function (style) { return style.SettingKey === settingKey.replace('_colorPlaceholderId', ''); })[0];
                            color = color ? color.SettingValue : null;
                        } else {
                            colorId = styleArray.filter(function (style) { return style.SettingKey === settingKey + '_colorPlaceholderId'; })[0];
                            colorId = colorId ? colorId.SettingValue : null;
                            color = this.SettingValue;
                        }

                        $(elem).DUIColorPicker({
                            layout: 'template',
                            selected: {
                                colorString: color,
                                templateColorId: colorId
                            }
                        });
                    } else {
                        // Textbox
                        $(elem).val(this.SettingValue);
                    }
                    $(elem).change();
                }
				else if ($(elem).is('input:checkbox')) {
					// Checkbox
					$(elem).attr('checked', (this.SettingValue.toLowerCase() == 'true') ? 'checked' : '');
					if (this.SettingKey === 'cell_autopadding' && this.SettingValue.toLowerCase() == 'true')
                        $(elem).parent('div').css('display', '');
                    else if (this.SettingKey === 'cell_autowidth' || this.SettingKey === 'cell_autoheight') {
						$(elem).attr('checked', (this.SettingValue == 'False') ? 'checked' : '');
					}

					if (isChartCreator)
						ChartCreatorUI.showHideTableStyleSettings(this.SettingKey, this.SettingValue);
                }
                else if ($(elem).is('input:radio')) {
                    // Radiobutton
					$(elem).attr('checked', (this.SettingValue.toLowerCase() == 'true') ? 'checked' : '');
                    $(elem).change(); //for styled radiobutton set checked/unchecked
                }
                else if (($(elem).is('select') || $(elem).is('input:hidden')) && this.SettingValue != '') {
                    // Dropdownlist or hidden field
                    if (this.SettingValue.includes(",") && (this.SettingKey === "ans_font" || this.SettingKey === "first_row_font" || this.SettingKey === "first_column_font"))
                    {
                        var sv = this.SettingValue.split(',')[0];
                        $(elem).val(sv);
                    }
                    else {
                        $(elem).val(this.SettingValue);
                    }
                }
                else if ($(elem).is('table')) {
                    //check box list
                    var cblist = $(elem).find('input:checkbox');
                    var cbvalues = this.SettingValue.split(';');
                    $.each(cbvalues, function () {
                        if (this.indexOf(":") > 0) {
                            var keyVal = this.split(':');
                            cblist.filter('input:checkbox[value="' + keyVal[0] + '"]').attr('checked', (keyVal[1].toLowerCase() == 'true') ? true : false);
                        }
                    });
                }
                else if ($(elem).is('div') && this.SettingValue != '') {
                    if ($(elem).hasClass('RTBorderStyle')) {
                        $(elem).children('.ChartStyleDashStyleValue')
                            .attr('data-value', this.SettingValue)
                            .css('background-image', "url('images/respondenttable_templates/" + this.SettingValue + ".png')");
                    }
                }
            }); //for each
            $("#rt_style_first_column").change(); //enable or disable first row and first column settings
            $("#rt_style_first_row").change();
            $('#rt_first_row_autowidth').change();
            $("#rt_cell_autopadding").change();
            $("#rt_cell_autowidth").change();
            $("#rt_cell_autoheight").change();

        }
    },
    getStyles: function (isChartCreator) {
		var dict = [];
		var styleTable = isChartCreator ? $('#chartCreatorStyles') : $("fieldset.rt_StyleTable");
		var prefix = isChartCreator ? 'cc_rt_' : 'rt_';
		var styleControlSelector = "[id^=" + prefix + "]";
		var styleList = $(styleTable).find(styleControlSelector);
        $(styleList).each(function (index) {
            var dictItem = {};
            var dictPlaceholder = {};
			var key = $(this).attr("id").substring(prefix.length);
            if ((key.lastIndexOf("_0") < 0) && //skip font style check boxes. we parse it using their parent table
                (key.lastIndexOf("_1") < 0) &&
                (key.lastIndexOf("_2") < 0)) {
                dictItem.SettingKey = key;
                if ($(this).is('input:text')) {

                    if ($(this).hasClass('numInput')) {
						dictItem.SettingValue = $(this).val();
						if ($(this).attr('valuesufix'))
							dictItem.SettingValue = dictItem.SettingValue.replace($(this).attr('valuesufix'), '');
                    }
                    else {
                        dictItem.SettingValue = $(this).attr("title");
                        if (dictItem.SettingValue == "") {
                            dictItem.SettingValue = "#000000";
                        }
                    }
                }
                else if ($(this).is('input:checkbox')) {
                    dictItem.SettingValue = $(this).is(':checked');
                    if (key === 'cell_autowidth' || key === 'cell_autoheight')
                        dictItem.SettingValue = !$(this).is(':checked');
                }
                else if ($(this).is('input:radio')) {
                    dictItem.SettingValue = $(this).is(':checked');
                }
                else if ($(this).is('select') || $(this).is('input:hidden')) {
                    dictItem.SettingValue = $(this).val();
                    if (dictItem.SettingKey === "ans_font" || dictItem.SettingKey === "first_row_font" || dictItem.SettingKey === "first_column_font")
                    {
                        dictItem.SettingValue = Storyboard.LayoutDesigner.UserEvents.getFontStackByFontFamily(dictItem.SettingValue);
                    }
                }
                else if ($(this).is('table')) {
                    var cblist = $(this).find('input:checkbox');
                    var cbvalues = "";
                    $.each(cblist, function () {
                        var cbVal = $(this).val();
                        var cbChecked = $(this).is(':checked');
                        cbvalues += cbVal + ":" + cbChecked + ";";
                    });
                    dictItem.SettingValue = cbvalues;
                }
                else if ($(this).hasClass('RTBorderStyle')) {
                    //name = $(this).attr('id').replace('chartstyle_', '');
                    var value = $(this).children('.ChartStyleDashStyleValue').attr('data-value');
                    dictItem.SettingValue = value;
                }
                if (dictItem.SettingValue != undefined && dictItem.SettingValue != null) {
                    dict.push(dictItem);
                }

                // Create template color setting
                if ($(this).hasClass('colorpicker-target') && $(this).DUIColorPicker('get.selectedColorId')) {
                    dictPlaceholder = {
                        SettingKey: key + '_colorPlaceholderId',
                        SettingValue: $(this).DUIColorPicker('get.selectedColorId')
                    };
                    if (dictPlaceholder.SettingValue != undefined && dictPlaceholder.SettingValue != null) {
                        dict.push(dictPlaceholder);
                    }
                }
            }
        });
        return dict;
    },
    showPreview: function () {
        var previewDiv = $("#rtDivPreview").empty();
        $("#rtExcelExportPreview, #rtCSVExportPreview").unbind('click').bind("click", function (evt) {
            evt.stopPropagation();
            var leguid = $(".layoutElementItem[guid='" + RespondentTableSetup.currentLayoutElementItem.guid + "']").closest('.layoutElement').attr('guid');
            var rtItemGuid = RespondentTableSetup.GetRTElementItemGuidBylayoutElementGuid(leguid);
            var respondentTableData = RespondentTableSetup.getRespondentTableSettingsData(leguid);
            var exportType = $(this).attr("id") === "rtExcelExportPreview" ? 4 : 5;

            Helpers.perfJSonCall({
                method: 'SaveRespondentTableSettings',
                data: {
                    guid: rtItemGuid,
                    layoutElementID: RespondentTableSetup.currentLayoutElementItem.layoutElementId || 0,
                    settings: respondentTableData,
                },
                service: 'RespondentTableSetup',
                successCallback: function (res) {
                    var leguid = $(".layoutElementItem[guid='" + RespondentTableSetup.currentLayoutElementItem.guid + "']").closest('.layoutElement').attr('guid');
                    RespondentTableSetup.ExportToExcel(leguid, exportType, true);
                }
            });
        });
        $(previewDiv).html('<div><label id="rtFilterInfo" style="display:block"></label><label id="rtTimePeriodInfo" style="display:block"></label></div><table id="rtPreviewTable"></table>');
        var table = $("#rtPreviewTable");
        //if user does not open settings tab yet, we explicitly call RespondentTableSetup.bindRowsDefs();
        RespondentTableSetup.bindRowsDefs();
        this.getRespondentTableData(previewDiv, table, this.renderTable, "", false, true); //set with empty guid, no fullscreen mode
    },
    getRespondentTableData: function (tableDiv, table, callbackShowTable, layoutElementGuid, isFullScreenMode, isPreview, fetchFromCache) {
        var filterSettings = GeneralSettings.getSelectedSettings();
        var settingsData = RespondentTableSetup.getRespondentTableSettingsData(layoutElementGuid);
        settingsData.IsFulscreenMode = isFullScreenMode;
        settingsData.TryToFetchFromCache = fetchFromCache; // true only for Select variables feature
        if (settingsData.LayoutElementItemGuid == undefined || settingsData.SettingId == undefined) {
            //if settings does not cached yet
            //we set for it layoutElementGuid and ElementItemID to get it from the server side            
            var le = Storyboard.LayoutDesigner.getLayoutElementByGuid(layoutElementGuid);
            if (le != undefined) {
                var leItem = Storyboard.LayoutDesigner.getElementItemByType(Storyboard.Constants.itemTypes.RESPONDENTTABLE, le);
                settingsData.SettingId = leItem.layoutElementId;
                settingsData.LayoutElementItemGuid = leItem.guid;
            }
        }
        var sortFilter = {};
        var cachedSettings = Storyboard.RespondentTableCache.getSettingsFromCache(settingsData.LayoutElementItemGuid);
        if (!cachedSettings) {
            var settings = {};
            Storyboard.RespondentTableCache.saveSettingsToCache(settings, settingsData.LayoutElementItemGuid);
            sortFilter.PageNrToReturn = 1;
        }
        else {
            sortFilter.PageNrToReturn = cachedSettings.PageNrToReturn;
            sortFilter.ColFilterSortList = cachedSettings.ColFilterSortList;
            sortFilter.VariablesToShow = cachedSettings.VariablesToShow;
            sortFilter.CompleteTableFilter = cachedSettings.CompleteTableFilter;
        }

        if (isPreview) {
            sortFilter = {};
        }
        Storyboard.LayoutControls.showLoadingBar(locale.get('Loading data...'));
        Helpers.perfJSonCall({
            data: {
                settings: settingsData,
                sortFilter: sortFilter,
                generalSettings: filterSettings,
                storyId: $("#ddlMyStories").val() || 0,
                slideId: Storyboard.LayoutDesigner.getCurrentSlide().slideId,
                respondentId: $('#ddlFormRespondents').val() || 0
            },
            method: "getRespondentTableData",
            successCallback: function (tableData) {
                callbackShowTable(tableDiv, table, tableData, settingsData, layoutElementGuid, true, isFullScreenMode);
            },
            fixCasing: true
        });
    },
    renderTable: function (tableDiv, table, tableData, settingsData, elemGuid, isReset, isFullscreen) {
        var elementItemGuid = RespondentTableSetup.GetRTElementItemGuidBylayoutElementGuid(elemGuid);
        var cachedSettings = Storyboard.RespondentTableCache.getSettingsFromCache(elementItemGuid);
        if (!cachedSettings) {
            cachedSettings = {};
        }

        if (!isFullscreen) {
            isFullscreen = false;
        }
        var isPreviewMode = false;
        if (RespondentTableSetup.currentLayoutElementItem && elemGuid == "") {
            isPreviewMode = true;
        }

        if (tableData.settings.tableWidth == 0) {
            //preview mode. //fb 16319. show width equals the control width
            if (isPreviewMode) {
                $("#rtDivPreview").css("width", RespondentTableSetup.currentLayoutElementItem.width || '100%');
                $("#rtDivPreview").css("height", RespondentTableSetup.currentLayoutElementItem.height || '100%');
                $("#rtDivPreview").css("overflow", "hidden");
                $("#resptabholder .invertBackground").show();
            }
        }

        if ((!Storyboard.LayoutDesigner.isAdmin || Helpers.isPreview()) && !isFullscreen && !isPreviewMode) {
            $(tableDiv).addClass("rtRespondentTableScrollableDiv");
        }
        var cssPrefixPattern = new RegExp('\\.layoutElementItem\\[guid="[-\\w]*"\\]', "g");
        if (isFullscreen) {
            if (tableDiv.parent().parent().get(0) !== document.body) {
                tableDiv.show().parent().addClass('fullScreenContainer animated zoomIn').appendTo(document.body);
                $(document.body).addClass('fullScreen');
            }
            tableData.tableHtml = tableData.tableHtml.replace(cssPrefixPattern, '#rtFullScreenTable');
        }

        if (isPreviewMode) {
            tableData.tableHtml = tableData.tableHtml.replace(cssPrefixPattern, '#rtPreviewTable');
        }

        $(table).html(tableData.tableHtml);

        if (Storyboard.LayoutDesigner.useNewNoDataLayout) {
            if ($(table).find('tbody').text() === 'No Data') {
                $(table).addClass('layoutElementNoDataText')
                    .html($('<span/>', { 'class': 'noData', html: locale.get('no data') }))
                    .css({ 'background-image': '' });
            } else {
                $(table).removeClass('layoutElementNoDataText');
            }
        }
        else if (typeof Storyboard.LayoutDesigner.useNewNoDataLayout === 'undefined') {
            if ($(table).find('tbody').text() === 'No Data') {
                $(table).find('tbody').remove();
            }
        }


        //preview mode. //fb 16319. show width equals the control width
        if (tableData.settings.tableWidth == 0) {
            if (isPreviewMode) {
                $(tableDiv).find("table").css("width", RespondentTableSetup.currentLayoutElementItem.width);
            }
            else {
                $(tableDiv).find("table").css("width", "100%");
            }
        }

        var frColumns = $("tr:first td", $(tableDiv));
        var hasData = true;
        if (frColumns.length == 0 || (frColumns.length == 1 && frColumns[0].innerText == "No Data")) {
            hasData = false;
        }

        // Check if there are different number of sort columns
        // or if columns don't have the same question IDs
        if (!RespondentTableSetup.colSorts[elemGuid] ||
            RespondentTableSetup.colSorts[elemGuid].colSort.length !== frColumns.length ||
            RespondentTableSetup.colSorts[elemGuid].colSort.map(function (column) { return column.QuestionID; }).join(',') !==
            frColumns.map(function (index, el) { return $(el).attr("questionId"); }).toArray().join(',')
        ) {
            if (hasData) {
                RespondentTableSetup.colSorts[elemGuid] = {};
                RespondentTableSetup.colSorts[elemGuid].colSort = [];

                frColumns.each(function () {
                    var index = frColumns.index(this);

                    if (!RespondentTableSetup.colSorts[elemGuid].colSort[index]) {
                        RespondentTableSetup.colSorts[elemGuid].colSort.push({ QuestionID: $(this).attr("questionId"), FilterText: "", SortType: 0 });
                    }
                });
                cachedSettings.ColFilterSortList = RespondentTableSetup.colSorts[elemGuid].colSort;
            } else if (cachedSettings.ColFilterSortList) {
                cachedSettings.ColFilterSortList.forEach(function (colFilter) {
                    colFilter.FilterText = '';
                });
            }
        }

        if (Storyboard.LayoutDesigner.isAdmin && !Helpers.isPreview())
            $(table).find("input.btnLinkToForm").attr('disabled', 'disabled');
        else {
            if (tableData.settings.isRespondentBlockEnabled) {
                if (tableData.settings.typeOfLockChecking === "periodically") {
                    RespondentTableSetup.checkForLocks(table);
                    setInterval(() => { RespondentTableSetup.checkForLocks(table) }, 10000);
                }
                else {
                    RespondentTableSetup.bindOnHoverLockChecks(table);
                }
            }

            $(table).find("input.btnLinkToForm").bind('click', function () {
                let $linkCell = $(this).parent();
                var respondentId = parseInt($linkCell.find("#hidRespId").val(), 10);
                var editable = $linkCell.find("#hidIsFormEditable").val() && $linkCell.find("#hidIsFormEditable").val().toLowerCase() == "true";
                if (editable && $linkCell.find('.respondentLockTooltip').length)
                    return;

                Helpers.perfJSonCall({
                    data: {
                        reportId: $linkCell.find("#hidRId").val(),
                        respondentId: respondentId,
                        isFormEditable: editable,
                        settingSelections: null
                    },
                    successCallback: function (result) {
                        if (editable && result.failedToLockRespondent) {
                            Storyboard.LayoutControls.showMessage(locale.get('The Form just got locked by another user, please try again later.'));
                        } else {
                            var elementGuid = $(table).closest('.layoutElement').attr('guid');
                            RespondentTableSetup.openFormReport(result.url, elementGuid, null, editable, respondentId,
                                result.lockExpirationTime, tableData.settings.isRespondentBlockEnabled);
                        }
                    },
                    message: locale.get('Loading respondent form'),
                    method: 'GetFormReportUrl',
                    service: "ReportService",
                    fixCasing: true
                });
            });
        }

        Storyboard.RespondentTableCache.saveSettingsToCache(cachedSettings, elementItemGuid);

        if (!cachedSettings.PageNrToReturn)
            cachedSettings.PageNrToReturn = 1;

        var pageNumber = tableData.currentPage || cachedSettings.PageNrToReturn;
        var tableSetup = RespondentTableSetup;
        RespondentTableSetup.generatePagingControls(tableData.pagesCount, tableDiv, pageNumber, tableSetup, isFullscreen, elemGuid);

        var completeTableSearch = tableData.settings.selectedVariables && tableData.settings.selectedVariables.length > 0 && (
            (tableData.settings.layoutType == 0 && (tableData.settings.searchType == 1 || tableData.settings.searchType == 2)) ||
            (tableData.settings.layoutType > 0 && tableData.settings.enableSearch == true));

        $("tbody tr:first", $(table)).addClass("headerRow");
        $('tbody', $(table)).before('<thead></thead>');

        var colWidth = '';
        var m = [];
        var filterSvgImg = 'data:image/svg+xml,%3Csvg%20width%3D%2216%22%20height%3D%2216%22%20viewBox%3D%220%200%2016%2016%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%3Cpath%20d%3D%22M15.6398%2013.54l-3.8375-3.8375c.5904-.9406.922-2.0526.905-3.2583C12.7243%202.9977%209.7258%200%206.2633%200%202.8053%200%200%202.8056%200%206.2632c0%203.4622%202.9985%206.461%206.4442%206.4442%201.165.0168%202.2422-.2947%203.186-.8327l3.8374%203.8375c.3686.3837.9792.3837%201.3396%200l.9774-.9413c.3703-.381.2352-.8557-.1448-1.231zM1.9188%206.2632c0-2.404%201.9425-4.3444%204.3444-4.3444%202.3908%200%204.5254%202.1348%204.5254%204.5254%200%202.4016-1.9414%204.3444-4.3444%204.3444-2.391%200-4.5254-2.1348-4.5254-4.5254z%22%20fill%3D%22%23D2D2D2%22%2F%3E%0A%3C%2Fsvg%3E';

        // one search box for the whole table
        if (completeTableSearch) {
            cachedSettings = Storyboard.RespondentTableCache.getSettingsFromCache(elementItemGuid);
            var text = "";
            
            if (cachedSettings && cachedSettings.CompleteTableFilter) {
                text = cachedSettings.CompleteTableFilter;
            }
            colWidth = 'style="width:' + ($(table).width() - 13) + 'px;"';
            m.push("<tr>");
            m.push("<td nowrap='nowrap' colspan='" + $(".headerRow td", $(tableDiv)).length + "'>");
            m.push('<input type="text" class="search_init search_row" perTable="true" ' + colWidth + ' autocomplete="off" />' +
                '<img class="RTSearchInitRow searchPerTable" title="' + locale.get("Search") + '" src="' + filterSvgImg + '" />');
            m.push("</td>");
            m.push("</tr>");
            $('thead', $(table)).append(m.join(''));

            $("thead .search_init.search_row", $(table)).val(text);

            if (text && text.length > 0) {
                $('tbody tr:not(.headerRow) td', $(table)).mark(text);
            }

            $("#rblTablelayout_0").click(function () {
                var cachedSettings = Storyboard.RespondentTableCache.getSettingsFromCache(elementItemGuid);
                cachedSettings.ColFilterSortList[0].FilterText = "";
                cachedSettings.PageNrToReturn = 1;
                Storyboard.RespondentTableCache.saveSettingsToCache(cachedSettings, elementItemGuid);
            });
        }

        // one search box per column
        if (tableData.settings.layoutType == 0 && (tableData.settings.searchType == 0 || tableData.settings.searchType == 2) &&
            tableData.settings.selectedVariables && tableData.settings.selectedVariables.length > 0 && hasData) {
            m = [];
            m.push("<tr>");
            var i = 0;
            var varInd = 0;

            var selectedVarsWithVisibleHeaders = tableData.settings.selectedVariables.filter(function (selVariable) { return !selVariable.header.hideByDefault; });
            $(".headerRow td", $(tableDiv)).each(function () {
                colWidth = 'style="width:' + ($(this).width() - 2) + 'px;"';
                m.push('<td nowrap="nowrap" ' + ($(this).is(":visible") ? '' : 'style="display:none;"') + '>');
                if ($(this).attr("questionid") !== '0' && selectedVarsWithVisibleHeaders[varInd]) {
                    if (selectedVarsWithVisibleHeaders[varInd].header.allowFilter == true)
                        m.push('<input type="text" class="search_init" value="" index="' + varInd + '"' + colWidth + ' autocomplete="off"/>' +
                            '<img class="RTSearchInit searchPerColumn" title="' + locale.get("Search") + '" src="' + filterSvgImg + '" index="' + varInd + '" />');
                    varInd++;
                }
                m.push('</td>');
                i++;
            });
            m.push("</tr>");
            $('thead', $(table)).append(m.join(''));

            $("#rblTablelayout_1, #rblTablelayout_2").click(function () {
                var cachedSettings = Storyboard.RespondentTableCache.getSettingsFromCache(elementItemGuid);
                cachedSettings.ColFilterSortList[0].FilterText = "";
                cachedSettings.PageNrToReturn = 1;
                Storyboard.RespondentTableCache.saveSettingsToCache(cachedSettings, elementItemGuid);
            });

            cachedSettings.ColFilterSortList
                .filter(function (column) { return column.QuestionID !== '0'; })
                .forEach(function (column, i) {
                    $("thead .search_init[index='" + i + "']", $(table)).val(column.FilterText);
                });

            cachedSettings.ColFilterSortList
                .forEach(function (column, i) {
                    if (column.FilterText && column.FilterText.length > 0) {
                        $('tbody tr:not(.headerRow) td:nth-child(' + (i + 1) + ')', $(table)).mark(column.FilterText);
                    }
                });

            // recalculate column widths after formatting rules image sizes are available
            RespondentTableSetup.onImagesLoaded(table);
        }

        if (tableData.settings.layoutType == 0 && (tableData.settings.freezeHeaderRow || tableData.settings.searchRowBgColorType == 1)) {
            var firstRowBgColor = $('tbody tr:first-child > td:first-child', $(table)).css('background-color');
            if (!firstRowBgColor || firstRowBgColor == 'trsansparent' || firstRowBgColor == 'rgba(0, 0, 0, 0)')
                firstRowBgColor = $('tbody tr:first-child', $(table)).css('background-color');
            $('thead tr > td', $(table)).css('background-color', firstRowBgColor);
        }

        if (tableData.settings.layoutType == 0 && tableData.settings.freezeHeaderRow) {
            var offset = 0;
            $('thead tr', $(table)).each(function () {
                $('>td', $(this)).css('position', 'sticky').css('top', offset + 'px');
                offset += $('>td:first-child', $(this)).outerHeight();
            });
        }

        $("thead img", $(table)).click(function () {
            var cachedSettings = Storyboard.RespondentTableCache.getSettingsFromCache(elementItemGuid);
            var colFilterSortList = cachedSettings.ColFilterSortList.filter(function (column) {
                return column.QuestionID !== '0';
            });

            $('thead img.searchPerColumn', $(table)).each(function () {
                var filterIndex = $(this).attr("index");
                var filterText = $("thead tr td input[index='" + filterIndex + "']", $(table)).val();
                colFilterSortList[filterIndex].FilterText = filterText;
            });

            $('thead img.searchPerTable', $(table)).each(function () {
                cachedSettings.CompleteTableFilter = $("thead input[perTable='true']", $(table)).val();
            });
            cachedSettings.PageNrToReturn = 1;

            Storyboard.RespondentTableCache.saveSettingsToCache(cachedSettings, elementItemGuid);
            RespondentTableSetup.getRespondentTableData(tableDiv, table, RespondentTableSetup.renderTable, elemGuid, tableData.settings.isFulscreenMode)
        });

        /* Update Header To Show Current Sorting and Filtering */
        if (cachedSettings.ColFilterSortList) {
            for (i = 0; i < cachedSettings.ColFilterSortList.length; i++) {
                var type = cachedSettings.ColFilterSortList[i].SortType;
                var sortClass = "";

                if (type == 1) {
                    sortClass = 'sorting_asc';
                }
                if (type == 2) {
                    sortClass = 'sorting_desc';
                }
                if (type != 0) {
                    $(".headerRow td", $(table)).eq(i).addClass(sortClass);
                }
            }
        }

        var variablesWithHeaders = tableData.settings.selectedVariables.filter(function (selVariable) { return selVariable.header.displayHeader; });

        if (variablesWithHeaders.length > 0) {
            if (tableData.settings.layoutType == 0 && tableData.settings.freezeHeaderRow) {
                var searchRowsHeight = 0;
                $('thead tr', $(table)).each(function () {
                    searchRowsHeight += $('>td:first-child', $(this)).outerHeight();
                });
                $('.headerRow td', $(table)).css('position', 'sticky').css('top', searchRowsHeight + 'px');
            }

            $(".headerRow td", $(table)).css("cursor", "pointer").click(function () {
                //clear previous sorttypes
                var cachedSettings = Storyboard.RespondentTableCache.getSettingsFromCache(elementItemGuid);

                var columns = $(".headerRow td", $(table));
                var sortIndex = columns.index(this);

                for (i = 0; i < cachedSettings.ColFilterSortList.length; i++) {
                    if (i != sortIndex) {
                        cachedSettings.ColFilterSortList[i].SortType = 0;
                    }
                }
                var sortType = cachedSettings.ColFilterSortList[sortIndex].SortType;
                switch (sortType) {
                    case 0:
                        cachedSettings.ColFilterSortList[sortIndex].SortType = 1;
                        break;
                    case 1:
                        cachedSettings.ColFilterSortList[sortIndex].SortType = 2;
                        break;
                    default:
                        cachedSettings.ColFilterSortList[sortIndex].SortType = 1;
                }

                Storyboard.RespondentTableCache.saveSettingsToCache(cachedSettings, elementItemGuid);
                RespondentTableSetup.getRespondentTableData(tableDiv, table, RespondentTableSetup.renderTable, elemGuid, tableData.settings.isFulscreenMode);
            });
        }

        $("thead input", $(table)).keydown(function (event) {
            if (event.keyCode == 13) {
                event.preventDefault();
                event.stopPropagation();
                $(this).next('img').click();
            }
        });

        $("thead input", $(table)).focus(function () {
            if (this.className == "search_init") {
                this.className = "";
            }
        });

        $("thead input", $(table)).blur(function (i) {
            if (this.value == "") {
                this.className = "search_init";
                this.value = "";
            }
        });

        if (!isPreviewMode && !isPreviewMode) {
            $(tableDiv).css({ 'background-image': 'none', 'background-color': 'transparent' });
        }

        // hide/show options root menu item 
        var layoutElementTableOptionsMenuButton = $(tableDiv).closest('.layoutElement').find('.tableOptions');
        var showOptions = tableData.settings.allowExcelExport || tableData.settings.allowCsvExport ||
            (tableData.settings.allowFullScreenMode && !window.IsFormReport) || tableData.settings.allowToHideVariables;
        $(layoutElementTableOptionsMenuButton).css("display", showOptions ? "inline-block" : "none");

        $(tableDiv).find("#rtFilterInfo").text(tableData.filterInfo[0]);
        $(tableDiv).find("#rtTimePeriodInfo").text(tableData.filterInfo[1]);

        Storyboard.LayoutControls.hideLoadingBar();
        cachedSettings.LayoutElementsToUpdate = tableData.settings.layoutElementsToUpdate;
        Storyboard.RespondentTableCache.saveSettingsToCache(cachedSettings, elementItemGuid);
        Storyboard.RespondentTableCache.setTableDataToCache(tableData, elementItemGuid);
        RespondentTableSetup.RenderEndUserOptions(tableDiv);
    },

    checkForLocks: function (table) {
        $(table).find("input.btnLinkToForm").toArray().forEach(linkBtn => {
            let $linkBtn = $(linkBtn);
            let $linkCell = $linkBtn.closest("td");
            let $hidRespId = $linkBtn.parent().find("#hidRespId");
            let respondentId = parseInt($hidRespId.val(), 10);
            
            $linkCell.find('.respondentLockTooltip').remove();

            let editable = $linkCell.find("#hidIsFormEditable").val() && $linkCell.find("#hidIsFormEditable").val().toLowerCase() == "true";

            if (!$hidRespId.parent().hasClass('respondentLockContainer')) {
                $linkCell.wrapInner('<div class="respondentLockContainer"></div>');
            }

            if (editable) {
                $.when(RespondentTableSetup.getRespondentLock(respondentId)).then(function (respLock) {
                    let lock = respLock.d;
                    if (lock != null) {
                        $linkBtn.attr('disabled', 'disabled');
                        $linkCell.bind('mouseenter', function () {

                            let lockedDate = new Date(lock.strStartTime);
                            let lockedAt = moment(lockedDate).format('HH:mm (YYYY-MM-DD)');

                            $linkCell.find('.respondentLockContainer').append('<span class="DUITooltipInfo respondentLockTooltip"><label>' +
                                '<i>' + locale.get('Locked by #USERNAME# at').replace('#USERNAME#', '</i>' + HTMLHelpers.htmlDecode(lock.userName) + '<br><i>') +
                                '</i> ' + lockedAt + '</label><br></span>');

                            $linkCell.find('.respondentLockContainer').addClass('open');

                            var respondentLockTooltip = $('.respondentLockTooltip', $linkCell);

                            if (window.UserType <= 3) {
                                // append to info panel
                                respondentLockTooltip.append("<input type='button' class='DUIButtonGray btnRemoveLock m-t-1' value='" + locale.get('Unlock') + "' />");
                                $linkCell.find(".btnRemoveLock").unbind("click").bind("click", function () {
                                    RespondentTableSetup.removeRespondentLockByAdmin($linkCell, $hidRespId.val());
                                });
                            }
                            respondentLockTooltip.show();
                        });

                        $linkCell.bind('mouseleave', function () {
                            let $linkCell = $(this).closest("td");

                            $linkCell.find('.respondentLockTooltip').remove();
                            $linkCell.find('.respondentLockContainer').removeClass('open');
                        });
                    }
                    else {
                        $linkBtn.removeAttr('disabled');
                        $linkCell.unbind('mouseenter');
                        $linkCell.unbind('mouseleave');
                        var respondentLockTooltip = $('.respondentLockTooltip', $linkCell);
                        respondentLockTooltip.hide();
                        $linkCell.find('.respondentLockContainer').removeClass('open');
                    }
                });
            }
        });
    },

    bindOnHoverLockChecks: function (table) {
        $(table).find("input.btnLinkToForm").bind('mouseenter', function () {
            let $linkBtn = $(this);
            let $linkCell = $linkBtn.closest("td");
            let $hidRespId = $linkBtn.parent().find("#hidRespId");
            let respondentId = parseInt($hidRespId.val(), 10);

            $linkCell.find('.respondentLockTooltip').remove();

            let editable = $linkCell.find("#hidIsFormEditable").val() && $linkCell.find("#hidIsFormEditable").val().toLowerCase() == "true";

            if (!$hidRespId.parent().hasClass('respondentLockContainer')) {
                $linkCell.wrapInner('<div class="respondentLockContainer"></div>');
            }

            if (editable) {
                $.when(RespondentTableSetup.getRespondentLock(respondentId)).then(function (respLock) {
                    let lock = respLock.d;
                    if (lock != null) {

                        let lockedDate = new Date(lock.strStartTime);
                        let lockedAt = moment(lockedDate).format('HH:mm (YYYY-MM-DD)');

                        $linkCell.find('.respondentLockContainer').append('<span class="DUITooltipInfo respondentLockTooltip"><label>' +
                            '<i>' + locale.get('Locked by #USERNAME# at').replace('#USERNAME#', '</i>' + HTMLHelpers.htmlDecode(lock.userName) + '<br><i>') +
                            '</i> ' + lockedAt + '</label><br></span>');

                        var respondentLockTooltip = $('.respondentLockTooltip', $linkCell);

                        $linkCell.find('.respondentLockContainer').addClass('open');

                        if (window.UserType <= 3) {
                            // append to info panel
                            respondentLockTooltip.append("<input type='button' class='DUIButtonGray btnRemoveLock m-t-1' value='" + locale.get('Unlock') + "' />");
                            $linkCell.find(".btnRemoveLock").unbind("click").bind("click", function () {
                                RespondentTableSetup.removeRespondentLockByAdmin($linkCell, $hidRespId.val());
                            });
                        }

                        respondentLockTooltip.show();
                    }
                });
            }
        });

        $(table).find("input.btnLinkToForm").bind('mouseleave', function () {
            let $linkCell = $(this).closest("td");

            $linkCell.find('.respondentLockTooltip').remove();
            $linkCell.find('.respondentLockContainer').removeClass('open');
        });
    },

    onImagesLoaded: function (table) {
        var images = $(table).find("tbody tr:not(.headerRow) img");
        var counter = images.length;
        var loading = false;

        images.each(function () {
            if (this.complete && this.naturalHeight !== 0) {
                counter--;
            } else {
                loading = true;
                $(this).bind('load', function () {
                    counter--;
                    if (counter == 0) RespondentTableSetup.updateCellWidths(table);
                });
            }
        });

        if (loading && counter == 0) RespondentTableSetup.updateCellWidths(table);
    },

    updateCellWidths: function (table) {
        var theadTDs = $(table).find('thead td');
        var tbodyTDs = $(table).find('tbody .headerRow td');
        var widths = [];

        if (theadTDs.first().attr('colspan') > 1) return;

        $(table).find('thead').css('display', 'none');
        $(table).find('thead td input').css('width', '');

        tbodyTDs.each(function (index) { widths[index] = $(this).width() - 2; });
        theadTDs.each(function (index) { $(this).find('input').css('width', widths[index]); });

        $(table).find('thead').css('display', '');
    },

    openFormReport: function (url, elementGuid, elementsToUpdateIds, isFormEditable, respondentId, lockExpirationTime, respondentLockEnabled, isCreateActionPlan) {
        var win = window, doc = document;

        if (self !== top && !isCrossOrigin() && (top.IsStoryboard || top.IsFormReport)) {
            win = parent;
            doc = parent.document;
        }

        var openForms = $('iframe.formReport', doc).length;
        var ifrFormReportID = openForms > 0 ? 'ifrFormReport' + openForms : 'ifrFormReport';
        var formHTML = "<iframe id='" + ifrFormReportID + "' class='formReport' style='width:100%; height:100%; border: 0' scrolling='no' />";

        function updateContent(elementsToUpdate) {
            if (window.IsFormReport) {
                Storyboard.LayoutDesigner.loadFormContent();
                if (self !== top)
                    window.frameElement.setAttribute("wasUpdated", 1);
            }
            else {
                var objsToUpdate = [];

                if (elementsToUpdate)
                    $(elementsToUpdate).each(function () { objsToUpdate.push(Storyboard.LayoutDesigner.getLayoutElementById(this)); });
                else if (elementGuid) {
                    objsToUpdate.push(Storyboard.LayoutDesigner.getLayoutElementByGuid(elementGuid));

                    var elementItemGuid = RespondentTableSetup.GetRTElementItemGuidBylayoutElementGuid(elementGuid);
                    var rtData = Storyboard.RespondentTableCache.getSettingsFromCache(elementItemGuid);
                    if (rtData != null && rtData.LayoutElementsToUpdate.length > 0) {
                        $(rtData.LayoutElementsToUpdate).each(function () {
                            objsToUpdate.push(Storyboard.LayoutDesigner.getLayoutElementById(this));
                        });
                    }
				}

				if (window.IsDrilldown)
					window.frameElement.setAttribute("wasUpdated", 1);

                Helpers.ThrottleQueue.clearThrottleQueue();
                Storyboard.LayoutDesigner.loadStorytellerContentForElements(objsToUpdate, true, true, 0, 0, "formSaved_" + elementGuid);
            }
        }

        var buttons = [];
        if (isFormEditable || isCreateActionPlan) {
            buttons = [
                {
                    text: locale.get('Save'),
                    closeWindow: false,
                    focused: true,
                    onClick: function(event) {
                        var iframeEl = doc.getElementById(ifrFormReportID);
                        var view = iframeEl.contentWindow ? iframeEl.contentWindow : iframeEl.contentDocument.defaultView;
                        var btnSave = $(event.target);

                        if (view) {
                            btnSave.attr('disabled', true);

                            $.when(view.DataFieldSetup.saveDataFieldsForRespondent())
                                .done(function () {
                                    btnSave.attr('disabled', false);

                                    // if datafields validation fails do nothing
                                    if (arguments[0] === false) return;

                                    RespondentTableSetup.removeRespondentLock(respondentId);
                                    formWin.Close();
                                    updateContent(elementsToUpdateIds);
                                });
                        }
                    }
                },
                {
                    text: locale.get('Cancel'),
                    closeWindow: false,
                    onClick: function () {
                        var iframeEl = doc.getElementById(ifrFormReportID);
                        RespondentTableSetup.CloseForm(respondentId);
                        RespondentTableSetup.removeRespondentLock(respondentId);
                        
                        if (iframeEl.getAttribute("wasUpdated") == 1)
                            updateContent(elementsToUpdateIds);
                        formWin.Close();
                    }
                }

            ];

            // TFS 19851 - wrong original text for Delete action respondent
            // Edit action plan
            if (respondentId < -100 && respondentId > -1000000000)
                buttons.push({
                    text: locale.get('Delete'),
                    closeWindow: false,
                    onClick: function () {
                        new DUIwindow2({
                            width: 420,
                            //title: '<h2>Delete Action</h2>',
                            html: '<p>' + locale.get('Are you sure you want to delete this action?') + '</p>',
                            //cssClass: 'colorTemplatesFormPopup',
                            preWrapSpace: false,
                            buttons: [
                                {
                                    text: locale.get('No'),
                                    closeWindow: true
                                },
                                {
                                    text: locale.get('Yes'),
                                    focused: true,
                                    onClick: function () {
                                        var iframeEl = doc.getElementById(ifrFormReportID);
                                        var view = iframeEl.contentWindow ? iframeEl.contentWindow : iframeEl.contentDocument.defaultView;
                                        if (view) {
                                            $.when(view.Storyboard.LayoutDesigner.deleteAction(respondentId))
                                                .done(function () {
                                                    RespondentTableSetup.removeRespondentLock(respondentId);
                                                    formWin.Close();
                                                    updateContent(elementsToUpdateIds);
                                                });
                                        }
                                    }
                                }
                            ]
                        });
                    }
                });
        } else {
            buttons = [
                {
                    text: locale.get('Close'),
                    closeWindow: false,
                    onClick: function () {
                        var iframeEl = doc.getElementById(ifrFormReportID);
                        if (iframeEl.getAttribute("wasUpdated") == 1)
                            updateContent(elementsToUpdateIds);
                        formWin.Close();
                    }
                }
            ];
        }

        var formWin = new win.DUIwindow2({
            title: '',
            width: $("#reportWrapper").width(),
            height: 766,
            preWrapSpace: false,
            buttons: buttons,
            html: formHTML,
            modal: true
        });

		function updateLockTimer(min, sec) {
			var minText = (min < 10 ? "0" : "") + min;
			var secText = (sec < 10 ? "0" : "") + sec;
			var message = locale.get('The form lock will expire in #MINUTES#:#SECONDS#\r\nTo save your changes click Save before the lock expires');
			var lockInfo = message.replace('#MINUTES#', minText)
				.replace("#SECONDS#", secText)
				.replace('\r\n', '<br>');

			$('#' + formWin.id + ' #lockExpirationTimer')
				.css('display', 'block')
				.html(lockInfo);

			sec -= 1;
			if (sec < 0) {
				min -= 1;
				sec = 59;
			}

			if ((min == 0 && sec == 0) || $('#' + formWin.id).length < 1) {
				$('#' + formWin.id + ' #lockExpirationTimer').remove();
				formWin.Close();
			} else
				setTimeout(function () { updateLockTimer(min, sec); }, 1000);
		}

		function checkCurrentLock(respondentId) {
			if ($('#' + formWin.id).length < 1)
				return;

			Helpers.perfJSonCall({
				data: {
					respondentId: respondentId
				},
				successCallback: function (status) {
					if (status === 'active')
						setTimeout(function () { checkCurrentLock(respondentId); }, Storyboard.GeneralSettings.respondentBlockCheckInterval * 1000);
					else {
						formWin.Close();
						if (stopDate > Date.now())
							Storyboard.LayoutControls.showMessage(locale.get('The Form was unlocked by the system Administrator.'));
					}
				},
				method: 'getLockStatus',
				service: "ReportService",
				fixCasing: true
			});
		}

		if (isFormEditable && respondentLockEnabled) {
			$('#' + formWin.id + ' .DUI-WINDOW-CLOSE').click(function (evt) {
				RespondentTableSetup.removeRespondentLock(respondentId);
			});

			if (lockExpirationTime) {
				$('#' + formWin.id).prepend('<span id="lockExpirationTimer" class="Message Message-warning lock-expiration-timer" style="display: none"></span>');

				var stopDate = new Date(lockExpirationTime.match(/\d+/)[0] * 1);
				setTimeout(function () { updateLockTimer(10, 0); }, stopDate - Date.now() - 10 * 60 * 1000);
			}

			setTimeout(function () { checkCurrentLock(respondentId); }, Storyboard.GeneralSettings.respondentBlockCheckInterval * 1000);
		}

        $(formWin.windowEl).parent().css('visibility', 'hidden');
        $("#MessagePopup").stop(true, true);

		win.Storyboard.LayoutControls.showLoadingBar(locale.get(isCreateActionPlan ? 'Loading action plan form' : 'Loading respondent form'));

        var iframeEl = doc.getElementById(ifrFormReportID);
        $(iframeEl).attr('src', url);
        if (iframeEl.contentWindow) {
            iframeEl.contentWindow.focus();
        } else if (iframeEl.contentDocument && iframeEl.contentDocument.documentElement) {
            iframeEl.contentDocument.documentElement.focus();
        }
    },

    lockLinkToFormButtons: function (table, respondentLocks) {
        table.find("input.btnLinkToForm").removeAttr("disabled");
		table.find('.respondentLockTooltip, .respondentLockMouseEvents').remove();

		$(respondentLocks).each(function () {
			var lock = this;
			table.find("input.hidRespId[value='" + lock.respondentId + "']").each(function () {
				var linkCell = $(this).closest("td");
				var editable = linkCell.find("#hidIsFormEditable").val() && linkCell.find("#hidIsFormEditable").val().toLowerCase() == "true";
				if (editable) {
					var lockedDate = new Date(lock.strStartTime);
					var lockedAt = moment(lockedDate).format('HH:mm (YYYY-MM-DD)');
					
					linkCell.find("input.btnLinkToForm")
						.attr("disabled", "disabled")
						.after('<div class="respondentLockMouseEvents"></div>');
					
					if (!$(this).parent().hasClass('respondentLockContainer')) {
						linkCell.wrapInner('<div class="respondentLockContainer"></div>');
					}

					linkCell.find('.respondentLockContainer').append('<span class="DUITooltipInfo respondentLockTooltip"><label>' +
						'<i>' + locale.get('Locked by #USERNAME# at').replace('#USERNAME#', '</i>' + lock.userName + '<br><i>') +
						'</i> ' + lockedAt + '</label><br></span>');

					var respondentLockTooltip = $('.respondentLockTooltip', linkCell);
					
					linkCell.unbind('mouseenter').bind('mouseenter', function () {
						respondentLockTooltip.show();
						linkCell.find('.respondentLockContainer').addClass('open');
					});
					
					linkCell.unbind('mouseleave').bind('mouseleave', function () {
						respondentLockTooltip.hide();
						linkCell.find('.respondentLockContainer').removeClass('open');
					});
					
					if (window.UserType <= 3) {
						// append to info panel
						respondentLockTooltip.append("<input type='button' class='DUIButtonGray btnRemoveLock m-t-1' value='"+ locale.get('Unlock') +"' />");
						linkCell.find(".btnRemoveLock").unbind("click").bind("click", function () {
							RespondentTableSetup.removeRespondentLockByAdmin(linkCell, linkCell.find("#hidRespId").val());
						});
					}

					if (linkCell.find('.respondentLockContainer').hasClass('open')) {
						respondentLockTooltip.show();
					}
                }
            });
        });
    },

    getRespondentLock: function (respondentId) {
        return Helpers.perfJSonCall({
            data: { respondentId: respondentId },
            method: 'GetRespondentLock',
            service: "ReportService",
            fixCasing: true
        });
    },

    updateRespondentLocks: function (table, restart) {
        // get respondent ids from all link to form buttons where form is editable
        var respondentIds = [];
        table.find("input.hidRespId").each(function () {
            var linkCell = $(this).parent();
            var editable = linkCell.find("#hidIsFormEditable").val() && linkCell.find("#hidIsFormEditable").val().toLowerCase() == "true";
            if (editable)
                respondentIds.push($(this).val());
        });

        Helpers.perfJSonCall({
            data: {
                respondentIds: respondentIds
            },
            successCallback: function (locks) {
				RespondentTableSetup.lockLinkToFormButtons(table, locks);
				if (restart && Storyboard.GeneralSettings.respondentBlockCheckInterval > 0)
                    setTimeout(function () { RespondentTableSetup.updateRespondentLocks(table, restart); }, Storyboard.GeneralSettings.respondentBlockCheckInterval * 1000);
            },
            method: 'getRespondentLocks',
            service: "ReportService",
            fixCasing: true
        });
    },

    CloseForm: function (respondentId) {
        Helpers.perfJSonCall({
            data: {
                respondentId: respondentId
            },
            method: 'CloseForm',
            service: "ReportService",
            fixCasing: true
        });
    },

    removeRespondentLockByAdmin: function (formLinkCell, respondentId) {
        Helpers.perfJSonCall({
            data: {
                respondentId: respondentId
            },
            successCallback: function () {
                // TODO: info panel
                formLinkCell.find("input.btnLinkToForm").removeAttr("disabled").removeAttr("title");
                formLinkCell.find(".btnRemoveLock").remove();
            },
            method: 'RemoveRespondentLockByAdmin',
            service: "ReportService"
        });
    },

    removeRespondentLock: function (respondentId) {
        Helpers.perfJSonCall({
            data: {
                respondentId: respondentId
            },
            method: 'RemoveRespondentLock',
            service: "ReportService"
        });
    },

    generatePagingControls: function (args, tableDiv, pageNumber, tableSetup, isFullScreenMode, elemGuid) {
        var pageNum = parseInt(pageNumber);
        pageNum = (pageNum > args) ? args : pageNum;
        var pagination = [];
        var pagerId = 'pager_' + elemGuid + (isFullScreenMode ? '_fs' : '');
        if (args > 1) {
            pagination.push('<div class="dataTables_paginate paging_full_numbers" id="' + pagerId + '">');
            if (pageNum > 1) {
                pagination.push('<span value="1" class="first  paginate_button paginate_button">' + locale.get('First') + '</span>');

                pagination.push('<span value="' + (pageNum - 1) + '" class="previous paginate_button paginate_button">' + locale.get('Previous') + '</span>');
            }
            for (var i = pageNum - 2; i <= (pageNum + 2); i++) {
                if (i >= 1 && i <= args) {
                    if (i != pageNum) {
                        pagination.push('<span value="' + i + '" class="paginate_button">' + i + '</span>');
                    }
                    else {
                        pagination.push('<span value="' + i + '" class="paginate_active">' + i + '</span>');
                    }
                }
            }
            if (pageNum < args) {
                pagination.push('<span value="' + (pageNum + 1) + '" class="next paginate_button">' + locale.get('Next') + '</span>');
                pagination.push('<span value="' + args + '" class="last paginate_button">' + locale.get('Last') + '</span>');
            }
            pagination.push('</div>');
            $('#' + pagerId).remove();
            $(tableDiv).append(pagination.join(''));

            $('#' + pagerId + ' .paginate_button').click(function () {
                var tmpItemGuid = RespondentTableSetup.GetRTElementItemGuidBylayoutElementGuid(elemGuid);
                var cachedSettings = Storyboard.RespondentTableCache.getSettingsFromCache(tmpItemGuid);
                cachedSettings.PageNrToReturn = $(this).attr("value");
                Storyboard.RespondentTableCache.saveSettingsToCache(cachedSettings, tmpItemGuid);
                tableSetup.getRespondentTableData(tableDiv, $("table", $(tableDiv)), tableSetup.renderTable, elemGuid, isFullScreenMode)
            });

        }
        else {
            $('#' + pagerId).remove();
        }
    },
    eventUpdateRespondentTable: function (layoutElement, tableData) {
        var itemTypes = Storyboard.Constants.itemTypes;
        var tableElem = Storyboard.LayoutDesigner.getElementItemByType(itemTypes.RESPONDENTTABLE, layoutElement);
        var tableDiv = $(".layoutElement[guid='" + layoutElement.guid + "']").find(".layoutElementRespondentTable")[0];
        var table = $(tableDiv).find(".layoutElementRespondentTableData");
        if ($(tableDiv).is(':empty')) {
            $(tableDiv).html('<div><label id="rtFilterInfo" style="display:block"></label><label id="rtTimePeriodInfo" style="display:block"></label></div><div class="layoutElementRespondentTableData"></div>');
            table = $(tableDiv).find(".layoutElementRespondentTableData");
        }
        var isReset = false;

        this.renderTable(tableDiv, table, tableData, null, layoutElement.guid, isReset, false);   //todo load settings from db
        this.saveRespondentTableHtml(tableDiv, tableElem);

        if (Storyboard.SlidesPanel && Storyboard.SlidesPanel.isOpen()) {
            var slide = Storyboard.LayoutDesigner.getSlideByLayoutElement(layoutElement);
            Storyboard.SlidesPanel.renderThumbnailFromSVGs([slide]);
        }
    },
    redrawRespondentTable: function (tableLayoutElementItem) {
        if (tableLayoutElementItem != null) {
            tableLayoutElementItem.content = '';
            $('#' + tableLayoutElementItem.guid).html('');
            if (tableLayoutElementItem.guid != "") {//element already has been saved
                var tableData = Storyboard.RespondentTableCache.getTableDataFromCache(tableLayoutElementItem.guid);
                if ((typeof tableData != 'undefined') && (tableData != null)) {
                    var tableDiv = $(".layoutElementItem[guid='" + tableLayoutElementItem.guid + "']");
                    var table = $(tableDiv).find(".layoutElementRespondentTableData");
                    if ($(tableDiv).is(':empty')) {
                        $(tableDiv).html('<div><label id="rtFilterInfo" style="display:block"></label><label id="rtTimePeriodInfo" style="display:block"></label></div><div class="layoutElementRespondentTableData"></div>');
                        table = $(tableDiv).find(".layoutElementRespondentTableData");
                    }
                    var isReset = $(table).is(':empty');
                    var tableGuid = $(tableDiv).closest('.layoutElement').attr('guid');
                    this.renderTable(tableDiv, table, tableData, null, tableGuid, isReset, false);
                }
            }
        }
    },
    showOptions: function (evt, layoutElementItem) {
        evt.stopPropagation();
        var offset = $(evt.currentTarget).offset();
        var posX = offset.left;
        var posY = offset.top + parseInt($(evt.currentTarget).outerHeight(), 10) - 1;
        var m = [];
        var tableLayoutElem = Storyboard.LayoutDesigner.getLayoutElementByElementItem(layoutElementItem);
        var guid = tableLayoutElem.guid;
        var respondentTableData = Storyboard.RespondentTableCache.getTableDataFromCache(layoutElementItem.guid);
        //remove old menu if exists 
        var className = '.' + guid + '.DUIContextMenu';
        $(className).remove();
        m.push('<ul class="DUIContextMenu ' + guid + '" style="top:' + posY + 'px;left:' + posX + 'px">');
        if (respondentTableData.settings.allowToHideVariables)
            m.push('<li><span id="DUI-RT-SHOW-HIDE-VARIABLES"><em>' + locale.get('Select variables', 1) + '</em></span></li>');
        if (respondentTableData.settings.allowFullScreenMode && !window.IsFormReport)
            m.push('<li><span id="DUI-RT-FULL-SCREEN"><em>' + locale.get('Full Screen') + '</em></span></li>');
        if (respondentTableData.settings.allowExcelExport)
            m.push('<li><span id="DUI-RT-EXPORT-EXCEL"><em>' + locale.get('Export to Excel') + '</em></span></li>');
        if (respondentTableData.settings.allowCsvExport)
            m.push('<li><span id="DUI-RT-EXPORT-CSV"><em>' + locale.get('Export to CSV') + '</em></span></li>');

        m.push('</ul>');

        // Add menu to body
        if (m.length > 2)
            $('body').append(m.join(''));
        $("#DUI-RT-EXPORT-EXCEL, #DUI-RT-EXPORT-CSV").bind("click", function (evt) {
            var exportType = $(this).attr("id") === "DUI-RT-EXPORT-EXCEL" ? 4 : 5;

            evt.stopPropagation();
            RespondentTableSetup.ExportToExcel(guid, exportType);
            $(className).remove();
        });
        $("#DUI-RT-FULL-SCREEN").bind("click", function (evt) {
            evt.stopPropagation();
            RespondentTableSetup.ShowFullScreen(guid);
            $(className).remove();
        });
        $("#DUI-RT-SHOW-HIDE-VARIABLES").bind("click", function (evt) {
            evt.stopPropagation();
            RespondentTableSetup.ShowSelectVariables(guid);
            $(className).remove();
        });
      
    },
    ShowSelectVariables: function (elementGuid) {
        var tmpItemGuid = RespondentTableSetup.GetRTElementItemGuidBylayoutElementGuid(elementGuid);
        var respondentTableData = Storyboard.RespondentTableCache.getTableDataFromCache(tmpItemGuid);

        var html = '<div><input type="text" id="txtSelVarsSearch" placeholder="' + locale.get("Search") + '" class="textbox searchbox fullInput" /><div class="respondent-table-variables-list">';

        $(respondentTableData.settings.selectedVariables).each(function () {
            var variable = this;
            var label = variable.header.useCustomHeader ? variable.header.customHeader : variable.questionText;
            var checked = variable.header.hideByDefault ? "" : " checked='checked'";
            var variableHtml =
                "<div><label><input type='checkbox' id='chkDisplayVar" + variable.questionId + "' value='" + variable.questionId + "' title='" + label + "'" + checked + "/> " +
                label + "</label></div>";
            html += variableHtml;
        });

        html += '</div></div>';

        var varsSelectWin = new DUIwindow2({
            width: 480,
            cssClass: "respondent-table-select-variables",
            title: '<h2>' + locale.get("Select variables to be shown", 1) + '</h2>',
            html: html,
            buttons: [
                {
                    text: locale.get("Cancel"),
                    cssClass: 'DUIButton',
                    closeWindow: true
                },
                {
                    text: locale.get("Select", 1),
                    cssClass: 'DUIButton',
                    focused: true,
                    onClick: function () {
                        var varsToShow = [];
                        $("input[id^='chkDisplayVar']").each(function () {
                            if ($(this).is(":checked"))
                                varsToShow.push($(this).val());
                        });
                        var cachedSettings = Storyboard.RespondentTableCache.getSettingsFromCache(tmpItemGuid);
                        cachedSettings.VariablesToShow = varsToShow;
                        Storyboard.RespondentTableCache.saveSettingsToCache(cachedSettings, tmpItemGuid);
                        var tableDiv = $(".layoutElement[guid='" + elementGuid + "']").find(".layoutElementRespondentTable")[0];
                        RespondentTableSetup.getRespondentTableData(tableDiv, $("table", $(tableDiv)), RespondentTableSetup.renderTable, elementGuid, false, false, true);
                    }
                }
            ],
            afterShow: function () {
                $("#txtSelVarsSearch").bind('keyup', function () {
                    var searchText = $("#txtSelVarsSearch").val().toLowerCase();
                    $("input[id^='chkDisplayVar']").each(function () {
                        var show = $(this).attr("title").toLowerCase().indexOf(searchText) > -1;
                        $(this).closest("div").css("display", show ? "" : "none");
                    });
                });
                $("input[id^='chkDisplayVar']").change(function () {
                    if ($("input[id^='chkDisplayVar']:checked").length < 1)
                        $(varsSelectWin.windowEl).find("input[id$='_btn1']").attr("disabled", "disabled");
                    else
                        $(varsSelectWin.windowEl).find("input[id$='_btn1']").removeAttr("disabled");
                });
            }
        });
    },
    ExportToExcel: function (elementGuid, exportType, notInQueue) {
        var layoutElem = Storyboard.LayoutDesigner.getLayoutElementByGuid(elementGuid);
        Storyboard.LayoutDesigner.clearElementContent(Storyboard.Constants.itemTypes.RESPONDENTTABLE);
        var treeID = "#hfilterTree";
        var sortFilter = { PageNrToReturn: 0, ColFilterSortList: null };
        var cacheGuid = RespondentTableSetup.GetRTElementItemGuidBylayoutElementGuid(elementGuid);
        var cachedSettings = Storyboard.RespondentTableCache.getSettingsFromCache(cacheGuid);
        var selectedHFilters = Storyboard.HFilterLayout.getSelectedIds(treeID, true);
        if (cachedSettings) {
            sortFilter.ColFilterSortList = cachedSettings.ColFilterSortList;
            sortFilter.CompleteTableFilter = cachedSettings.CompleteTableFilter;
        }

        var data = {
            layoutElement: layoutElem,
            sortFilter: sortFilter,
            storyId: $("#ddlMyStories").val() || 0,
            respondentId: $('#ddlFormRespondents').val() || 0,
            exportType: exportType,
            selectedHFilterNodes: selectedHFilters,
            fileName: $("#txtExportFileName").val() || "default",
        };

        if (!notInQueue && Storyboard.GeneralSettings.storeSingleObjectExports) {
            var params = {
                data: data,
                method: "QueueObjectExport"
            };

            if ($(".downloadcontainer:visible").length < 1)
                $("#btnOpenExportPanel").click();
            Storyboard.LayoutDesigner.queueExport(params);
        } else {
            Helpers.perfJSonCall({
                data: data,
                method: "RespondentTableGenerateExcel",
                message: locale.get("Preparing " + (exportType == 4 ? "Excel" : "CSV") + " download"),
                successCallback: function (res) {
                    var downloadKey = res;
                    var frame = document.getElementById('fileFrame');
                    if (frame == null) {
                        frame = document.createElement("iframe");
                        frame.name = "fileFrame";
                        frame.id = "fileFrame";

                        document.body.appendChild(frame);
                        frame.style.width = "0px";
                        frame.style.height = "0px";
                        frame.style.border = "0px";
                    }
                    frame.src = "DownloadFile.aspx?downloadKey=" + downloadKey;
                }
            });
        }
        
    },
    ShowFullScreen: function (elementGuid) {
        var tableDiv = $('#rt_fullScreenContainer').hide();
        $(tableDiv).html('<button id="rt_ExitFullScreen" type="button" title="Exit Full Screen" class="DUI-Setup-close exitFullScreenButton">×</button><div><label id="rtFilterInfo" style="display:block"></label><label id="rtTimePeriodInfo" style="display:block"></label></div><table id="rtFullScreenTable"></table>');
        var table = $("#rtFullScreenTable");

        $('#rt_ExitFullScreen').bind('click', RespondentTableSetup.HideFullScreen);
        $(document).bind('keyup.rt_fullScreenContainer', function(evt) {
            if (evt.keyCode == 27) RespondentTableSetup.HideFullScreen();
        });

        RespondentTableSetup.getRespondentTableData(tableDiv, table, this.renderTable, elementGuid, true); //set fullscreen mode
    },
    HideFullScreen: function() {
        var tableDiv = $('#rt_fullScreenContainer');
        
        tableDiv.parent().removeClass('fullScreenContainer animated zoomIn').insertAfter($('#pageStoryTeller'));
        tableDiv.empty();

        $(document.body).removeClass('fullScreen');
        $(document).unbind('keyup.rt_fullScreenContainer');
    },
    saveRespondentTableHtml: function (tableDiv, tableElem) {
        var tableClone = $(tableDiv).clone();
        $(tableClone).find(":input").remove();
        var htmlContent = $(tableClone).html();
        $(tableClone).remove();

        tableElem.content = htmlContent;
    },
    radioStyledInit: function (input) {
        var span = Array();
        $(input).each(function (index) {
            span[index] = document.createElement("span");
            var inputclass = $(this).attr("class");
            var buttontypeclass = inputclass.split(" ")[1];
            $(span[index]).addClass(buttontypeclass + ' radiostyled_span');
            if ($(this).is(":checked")) {
                $(span[index]).addClass('selected');
            }
            $(this).before(span[index]);
            $(this).change(function () {
                if ($(this).is(":checked") && $(this).hasClass("radiostyled")) {
                    $(this).prev().addClass('selected');
                } else if ($(this).hasClass("radiostyled")) {
                    $(this).prev().removeClass('selected');
                }
            });
            if (!$(this).is(":disabled")) {
                $(span[index]).removeClass("radio_styled_disabled");
                $(span[index]).mousedown(function () {
                    var element = this.nextSibling;
                    if ($(element).is(":disabled")) {
                        return;
                    }
                });
                $(span[index]).mouseup(function () {
                    var element = this.nextSibling;
                    if ($(element).is(":disabled")) {
                        return;
                    }

                    var group = this.nextSibling.name;
                    $('input[name="' + group + '"]').prev().removeClass('selected');
                    $(this).addClass('selected');

                    element.checked = true;
                });
            } else {
                $(span[index]).addClass("radio_styled_disabled");
            }
        });
    },
    RenderEndUserOptions: function (tableDiv) {
        if (tableDiv) {
            var elem = $(tableDiv).closest('.layoutElement');
            if ($(elem).length === 1 && $(elem).has(".DUIToolbar").length == 0) {
                var elementItem = $(elem).find(".layoutElementRespondentTable");

                var leGuid = $(elem).attr('guid');
                var le = Storyboard.LayoutDesigner.getLayoutElementByGuid(leGuid);
                var leItem = Storyboard.LayoutDesigner.getElementItemByType(Storyboard.Constants.itemTypes.RESPONDENTTABLE, le);
                var respondentTableData = leItem != null ? Storyboard.RespondentTableCache.getTableDataFromCache(leItem.guid) : null;
                var optionsNo = 0;
                if (respondentTableData.settings.allowExcelExport)
                    optionsNo++;
                if (respondentTableData.settings.allowCsvExport)
                    optionsNo++;
                if (respondentTableData.settings.allowFullScreenMode && !window.IsFormReport)
                    optionsNo++;
                if (respondentTableData.settings.allowToHideVariables)
                    optionsNo++;

                if ($(elem).find(".rtExcelExportPreview").length == 0 && respondentTableData != null) {
                    if (optionsNo > 1)
                        $(elementItem).prepend('<span class="DUIButton editContent standardButton previewExport rtExcelExportPreview rtOptionsMenuItemRoot">' + locale.get('Options') + '</span>');
                    else if (respondentTableData.settings.allowExcelExport)
                        $(elementItem).prepend('<span class="DUIButton editContent standardButton previewExport rtExcelExportPreview rtOptionsMenuItemExcel">' + locale.get('Export to Excel') + '</span>');
                    else if (respondentTableData.settings.allowCsvExport)
                        $(elementItem).prepend('<span class="DUIButton editContent standardButton previewExport rtExcelExportPreview rtOptionsMenuItemCSV">' + locale.get('Export to CSV') + '</span>');
                    else if (respondentTableData.settings.allowFullScreenMode && !window.IsFormReport)
                        $(elementItem).prepend('<span class="DUIButton editContent standardButton previewExport rtExcelExportPreview rtOptionsMenuItemFullscreen">' + locale.get('Full Screen') + '</span>');
                    else if (respondentTableData.settings.allowToHideVariables)
                        $(elementItem).prepend('<span class="DUIButton editContent standardButton previewExport rtExcelExportPreview rtOptionsMenuItemSelectVars">' + locale.get('Select variables', 1) + '</span>');

                    $(elementItem)
                        .delegate('.search_init', 'focus', function () { $(elementItem).find(".rtExcelExportPreview").hide(); })
                        .delegate('.search_init', 'blur', function () { $(elementItem).find(".rtExcelExportPreview").show(); });
                }

                var btn = $(elem).find(".rtExcelExportPreview");
                var btnRoot = $(elem).find(".rtOptionsMenuItemRoot");
                var btnFullscreen = $(elem).find(".rtOptionsMenuItemFullscreen");

                $(btn).hide();
                $(elementItem).mouseenter(function () { $('.DUIContextMenu').remove(); $(this).find(".rtExcelExportPreview").show(); });
                $(elementItem).mouseleave(function () { $('.DUIContextMenu').remove(); $(this).find(".rtExcelExportPreview").hide(); });
                $(btn).unbind('mouseenter');
                $(btn).mouseenter(function (evt) {
                    $(this).show();
                    evt.preventDefault();
                    evt.stopPropagation();
                });
                $(btn).unbind('mouseleave');
                $(btn).mouseleave(function (evt) {
                    evt.preventDefault();
                    evt.stopPropagation();
                });
                $(btnRoot).unbind('click');
                $(btnRoot).bind("click", function (evt) {
                    evt.stopPropagation();
                    var leguid = $(elem).attr('guid');
                    var le = Storyboard.LayoutDesigner.getLayoutElementByGuid(leguid);
                    var leItem = Storyboard.LayoutDesigner.getElementItemByType(Storyboard.Constants.itemTypes.RESPONDENTTABLE, le);
                    RespondentTableSetup.showOptions(evt, leItem);
                });
                $(".rtOptionsMenuItemExcel, .rtOptionsMenuItemCSV", elem).unbind('click');
                $(".rtOptionsMenuItemExcel, .rtOptionsMenuItemCSV", elem).bind("click", function (evt) {
                    evt.stopPropagation();
                    var tableLayoutElementItemGuid = $(evt.currentTarget).parent().attr('guid');
                    var tableLayoutElementItem = Storyboard.LayoutDesigner.getElementItemByGuid(tableLayoutElementItemGuid);
                    var tableLayoutElem = Storyboard.LayoutDesigner.getLayoutElementByElementItem(tableLayoutElementItem);

                    var exportType = $(this).hasClass("rtOptionsMenuItemExcel") ? 4 : 5;
                    RespondentTableSetup.ExportToExcel(tableLayoutElem.guid, exportType);
                });
                $(btnFullscreen).unbind('click');
                $(btnFullscreen).bind("click", function (evt) {
                    evt.stopPropagation();
                    var tableLayoutElementItemGuid = $(evt.currentTarget).parent().attr('guid');
                    var tableLayoutElementItem = Storyboard.LayoutDesigner.getElementItemByGuid(tableLayoutElementItemGuid);
                    var tableLayoutElem = Storyboard.LayoutDesigner.getLayoutElementByElementItem(tableLayoutElementItem);
                    RespondentTableSetup.ShowFullScreen(tableLayoutElem.guid);
                });

                var btnSelectVars = $(elem).find(".rtOptionsMenuItemSelectVars");
                $(btnSelectVars).unbind("click").bind("click", function (evt) {
                    evt.stopPropagation();
                    var tableLayoutElementItemGuid = $(evt.currentTarget).parent().attr('guid');
                    var tableLayoutElementItem = Storyboard.LayoutDesigner.getElementItemByGuid(tableLayoutElementItemGuid);
                    var tableLayoutElem = Storyboard.LayoutDesigner.getLayoutElementByElementItem(tableLayoutElementItem);
                    RespondentTableSetup.ShowSelectVariables(tableLayoutElem.guid);
                });

                Storyboard.LayoutDesigner.openFormReportFromLink();
            }
            
            $(document).trigger('DAPI.respondentTableLoaded', [elem]);
        }
    },
    QsortSelVars: function (data) {
        var a = data;
        var f_compare;
        var f_change;
        if (!(a instanceof Array)) { // Data are not array
            return undefined;
        }
        if (a.length == 0) {
            return undefined;
        }
        if (f_compare == undefined) {
            f_compare = function (a, b) {
                return ((a == b) ? 0 : ((a > b) ? 1 : -1));
            };
        }
        if (f_change == undefined) {
            f_change = function (a, i, j) { var c = a[i]; a[i] = a[j]; a[j] = c; };
        }

        var qs = function (l, r) {
            var i = l,
            j = r,
            x = a[Math.floor(Math.random() * (r - l + 1)) + l].Header.SortOrder;
            // x = a[l].Header.SortOrder; // if we does not want to use Math

            while (i <= j) {
                while (f_compare(a[i].Header.SortOrder, x) == -1) { i++; }
                while (f_compare(a[j].Header.SortOrder, x) == 1) { j--; }
                if (i <= j) { f_change(a, i++, j--); }
            }
            if (l < j) { qs(l, j); }
            if (i < r) { qs(i, r); }
        };

        var isHasDuplicates = false;
        var removeDuplicates = function () {
            for (var i = 0; i < a.length - 1; i++) {
                for (var j = i + 1; j < a.length; j++) {
                    if (a[i].Header.SortOrder == a[j].Header.SortOrder) {
                        a[j].Header.SortOrder++;
                        isHasDuplicates = true;
                    }
                }
            }
        }
        qs(0, a.length - 1);
        removeDuplicates();
        while (isHasDuplicates) {
            isHasDuplicates = false;
            removeDuplicates();
        }
    },
    GetRTElementItemGuidBylayoutElementGuid: function (layoutElementGuid) {
        var guid = "";
        var le = Storyboard.LayoutDesigner.getLayoutElementByGuid(layoutElementGuid);
        if (le) {
            var leItem = Storyboard.LayoutDesigner.getElementItemByType(Storyboard.Constants.itemTypes.RESPONDENTTABLE, le);
            if (leItem) {
                guid = leItem.guid;
            }
        }
        return guid;
    },
    SetSVSubsets: function (vsArray) {
        RespondentTableSetup.ShowHideSVFilter(vsArray, "#rtFilterPanel", "#chkrtVS");
        HTMLHelpers.setSelectedValues('#lbrtVS', vsArray);
    },
    ShowHideSVFilter: function (array, panel, checkbox) {
        if (array && array.length > 0) {
            $(panel).css("display", "inherit");
            $(checkbox).attr("checked", true);
        }
        else {
            $(panel).css("display", "none");
            $(checkbox).attr("checked", false);
        }
    },
    showHideDisplayByDefault: function () {
        var show = $("#chkAllowToHideVariables").is(":checked");
        $('.rtShowByDefault').css("display", show ? "" : "none");
    },
    showHideAllowSearch: function () {
        var columnLayout = $("#rblTablelayout_0").is(":checked");
        var perColumnSearch = $("#ddlRTSearchType").val() == 0;
        $(".rtAllowFilterColumn").css("display", columnLayout && perColumnSearch ? "" : "none");
    },

    showHideSortBy: function () {
        var columnLayout = $("#rblTablelayout_0").is(":checked");
        $(".rtSortBy").css("display", columnLayout ? "" : "none");
    },
    showHideSearchInHidden: function () {
        var perTableSearch = $("#ddlRTSearchType").val() == 1;
        var allowHiddenColumns = $('#chkAllowToHideVariables').attr("checked");
        $("#chkSearchInHiddenColumns").closest("span").css("display", perTableSearch && allowHiddenColumns ? "" : "none");
    },
	showHideLowRespOrDataSettings: function () {
		$('.rtHideLowRespOrDataRules').toggle($('#cbHideLowRespOrData').is(':checked'));
		if ($('#cbHideLowRespOrData').is(':checked') && $('#divLowRespOrDataRulesContainer div').length == 0) {
			var block = $('#rtHideLowRespRuleTemplate > div').clone();
			$('#divLowRespOrDataRulesContainer').append(block);
		}
	},
	updateHideLowDataOptions: function () {
		var optionHtml = '<option value="-1">Respondents</option>';
		$('#selectedVarBox option').each(function () {
			var qId = $(this).val();
			if (parseInt(qId, 10) > 0) {
				var text = $(this).attr("questiontext");
				optionHtml += '<option value="' + qId + '">Data values in ' + text + '</option>';
			}
		});

		$('.ddlHideLowRespOrDataObject').each(function () {
			var selection = $(this).val();
			$(this).find('option').remove();
			$(this).append(optionHtml);
			HTMLHelpers.setSelectedValues($(this), selection);
		});

		RespondentTableSetup.hideShowDuplicateOptions();
		RespondentTableSetup.enableDisableLowDataRuleBtn();
	},
	hideShowDuplicateOptions: function () {
		$('#divLowRespOrDataRulesContainer .ddlHideLowRespOrDataObject span > option').unwrap();

		$('#divLowRespOrDataRulesContainer .divHideLowRespRule').each(function () {
			var selected = $(this).find('.ddlHideLowRespOrDataObject').val();
			$('#divLowRespOrDataRulesContainer .divHideLowRespRule .ddlHideLowRespOrDataObject > option[value="' + selected + '"]').wrap('<span>').parent().hide();
			$(this).find('.ddlHideLowRespOrDataObject span > option[value = "' + selected + '"]').unwrap();
		});
	},
	enableDisableLowDataRuleBtn: function () {
		if ($('#rtHideLowRespRuleTemplate .ddlHideLowRespOrDataObject option').length > $('#divLowRespOrDataRulesContainer .divHideLowRespRule').length)
			$('#btnAddLowRespOrDataRule').removeAttr('disabled');
		else
			$('#btnAddLowRespOrDataRule').attr('disabled', 'disabled');
	},
	showHideTimeSelections: function () {
		$('#rtTimeSelections').toggle($('#chkEnableCustomerHistory').is(':checked'));
	},
    onTableLayoutChanged: function () {
        var selectedItems = $("#selectedVarBox option");
        var selVariables = [];
        //get selected variables already changed by user
        var userSelVariables = RespondentTableSetup.getSelectedVariables();
        selectedItems.each(function () {
            //get header default values from the cache
            var variable = RespondentTableSetup.getSelecetdVariablesFromCahce(this.value, userSelVariables);
            selVariables.push(variable);
        });
        var columnLayout = $("#rblTablelayout_0").is(":checked");
        var rowsRespondentsInBlocksLayout = $("#rblTablelayout_2").is(":checked");
        RespondentTableSetup.showHideAllowSearch();
        RespondentTableSetup.showHideSortBy();
		$("#divRTSearchFields").css("display", columnLayout ? "" : "none");
		$("#cbFreezeHeaderRow").parent('.settingItem').css("display", columnLayout ? "" : "none");
        $("#cbEnableSearch").css("display", columnLayout ? "none" : "").next().css("display", columnLayout ? "none" : "");
        $('#rtSorting').css("display", columnLayout && !window.IsFormReport ? "" : "none");
        if (selVariables.filter(function (v) { return v.IsStacked; }).length > 0) {
            $("#stackedDataLayoutSettings").css("display", rowsRespondentsInBlocksLayout ? "none" : "");
		}
		$('#fsSearchBgColor').toggle(columnLayout && !$('#cbFreezeHeaderRow').is(':checked'));
	},
	clearWebVariablesCache: function () {
		Helpers.perfJSonCall({
			method: "ClearWebVariablesCache",
			successCallback: function () {
				Storyboard.LayoutControls.showMessage('Cached images cleared');
			}
		});
	},
    initWizard: function (templateId) {
        var $setup = $('#setupRespondentTab');

        // Append controls to Wizard
        $('#wizardRespondentVariables').append($setup.find('#resptabholder #data .settingsBoxFull'));
        $('#wizardRespondentFilters').append($setup.find('#resptabholder #rtFilterBox'));
        $('#wizardRespondentTime').append($setup.find('#resptabholder #rtTimeSelections').removeClass('expandable collapsable'));
        $('#wizardRespondentPreview').append($setup.find('#preview'));

        $('#setupRespondentTab .availVarBox, #setupRespondentTab .selectedVarBox').addClass('size-1-2');

        $('#wizardRespondentPreviewButton').unbind('click.wizardSetup').bind('click.wizardSetup', function() { 
            RespondentTableSetup.showPreview();
        });

        // Hide
        $setup.find('#resptabholder, #setupRespondentTab #preview .DUIToolbar').css('display', 'none');
        $('#DUI-ST-MULTIEDIT').css('display', 'none');
        $('#wizardRespondent').css('display', '').find('.tabs + .expandable > .settingsFieldsetLegend').trigger('click');
        $('#setupHolder').addClass('setupWizard');

        // Template Data
        if (templateId != null) {
            $('#wizardRespondent .dataSection').show();
            $('#wizardRespondentVariables').closest('fieldset').removeClass('collapsable').addClass('expandable');
        }
        else {
            $('#wizardRespondent .dataSection').hide();
            $('#wizardRespondentVariables').closest('fieldset').removeClass('expandable').addClass('collapsable');
        }
    },
    destroyWizard: function() {
        var $setup = $('#setupRespondentTab');

        if ($('#resptabholder > .tabs .setupWizardInit').length === 0) {
            $setup.find('#resptabholder > .tabs').prepend('<li class="ui-state-default setupWizardInit"><a>Wizard</a></li>');
            $('#resptabholder > .tabs .setupWizardInit').bind('click', RespondentTableSetup.initWizard);
        }

        $('#setupRespondentTab .availVarBox, #setupRespondentTab .selectedVarBox').removeClass('size-1-2');

        // Append controls to chart setup
        $setup.find('#data').append($('#wizardRespondentVariables .settingsBoxFull'));
        $setup.find('#filters .settingsFieldset:first-child .settingsFieldsetContent').append($('#wizardRespondentFilters #rtFilterBox'));
        $setup.find('#respFormattingRules').after($('#rtTimeSelections').addClass('expandable'));
        $setup.find('.preview-groupings').prepend($('#wizardRespondentPreview #preview'));

        $setup.find('#resptabholder, #DUI-ST-MULTIEDIT, #preview .DUIToolbar').css('display', '');
        $('#DUI-ST-MULTIEDIT').css('display', 'none');
        $('#wizardRespondent').css('display', 'none');
        $('#setupHolder').removeClass('setupWizard');
    },
    removeWizard: function() {
        if ($('#setupHolder').hasClass('setupWizard')) RespondentTableSetup.destroyWizard();
        $('#resptabholder > .tabs .setupWizardInit').remove();
    }
};
